/* eslint-disable */
import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string;
  String: string;
  Boolean: boolean;
  Int: number;
  Float: number;
  /** The `Upload` scalar type represents a file upload. */
  Upload: any;
};

export type Address = {
  /** Name of city or city district (ex. København K) */
  city: Scalars['String'];
  /** Residence door if building or floor has multiple doors (ex. TH) */
  door?: Maybe<Scalars['String']>;
  /** Residence floor if building has multiple floors (ex. 1.) */
  floor?: Maybe<Scalars['String']>;
  /** House number on street (ex. 24A) */
  houseNumber: Scalars['String'];
  id?: Maybe<Scalars['Int']>;
  /** City postal code (ex. 2800) */
  postalCode: Scalars['String'];
  /** Name of street without house number (ex. Vesterbrogade) */
  street: Scalars['String'];
};

export type AddressInput = {
  /** Name of city or city district (ex. København K) */
  city: Scalars['String'];
  /** Residence door if building or floor has multiple doors (ex. TH) */
  door?: InputMaybe<Scalars['String']>;
  /** Residence floor if building has multiple floors (ex. 1.) */
  floor?: InputMaybe<Scalars['String']>;
  /** House number on street (ex. 24A) */
  houseNumber: Scalars['String'];
  /** City postal code (ex. 2800) */
  postalCode: Scalars['String'];
  /** Name of street without house number (ex. Vesterbrogade) */
  street: Scalars['String'];
};

export type AllOfferSavings = {
  disclaimer: Scalars['String'];
  residence?: Maybe<SimpleResidenceResult>;
  results: Array<OfferSavingsWithProducts>;
};

export type AssortedOfferInput = {
  assortedProducts: Array<ProductInput>;
  discount?: InputMaybe<Scalars['Int']>;
  discountWithoutInstallation?: InputMaybe<Scalars['Int']>;
  expenses?: InputMaybe<Array<OfferExpenseInput>>;
  notes?: InputMaybe<Scalars['String']>;
  reservations?: InputMaybe<Scalars['String']>;
  withoutInstallation?: InputMaybe<Scalars['Boolean']>;
};

export type AssortedProduct = {
  brand: Scalars['String'];
  buyPrice?: Maybe<Scalars['Float']>;
  datasheetUrl?: Maybe<Scalars['String']>;
  deletedAt?: Maybe<Scalars['Float']>;
  descriptionId?: Maybe<Scalars['Int']>;
  id: Scalars['Float'];
  imageUrl?: Maybe<Scalars['String']>;
  model: Scalars['String'];
  offerID?: Maybe<Scalars['Float']>;
  price: Scalars['Float'];
  quantity?: Maybe<Scalars['Float']>;
  size: HeatPumpSize;
};

export type AssortedProductInput = {
  boxSize?: InputMaybe<BoxSizeInput>;
  brand: Scalars['String'];
  buyPrice?: InputMaybe<Scalars['Float']>;
  cylinderSize?: InputMaybe<CylinderSizeInput>;
  datasheetUrl?: InputMaybe<Scalars['String']>;
  deletedAt?: InputMaybe<Scalars['Float']>;
  descriptionId?: InputMaybe<Scalars['Int']>;
  imageUrl?: InputMaybe<Scalars['String']>;
  model: Scalars['String'];
  price: Scalars['Float'];
};

export type AuthProvider = {
  type: AuthProviderType;
  userID: Scalars['String'];
};

export type AuthProviderType =
  | 'google';

export type BankCustomerLead = {
  address: AddressInput;
  /** Bank branch at which customer advisor works */
  advisorBranch?: InputMaybe<Scalars['String']>;
  /** Email of advisor assigned to customer */
  advisorEmail?: InputMaybe<Scalars['String']>;
  /** Name of advisor assigned to customer */
  advisorName?: InputMaybe<Scalars['String']>;
  /** Any comments that might be relevant */
  comments?: InputMaybe<Scalars['String']>;
  desiredProducts?: InputMaybe<Array<LeadProductTypeEnum>>;
  /** Customer email address */
  email: Scalars['String'];
  /** Given first name(s) */
  firstName: Scalars['String'];
  /** Legal surname */
  lastName: Scalars['String'];
  /** Phone number including country code (+45) */
  phoneNumber: Scalars['String'];
  /** Universally unique lead identifier */
  uuid: Scalars['String'];
};

export type Battery = {
  brand: Scalars['String'];
  buyPrice?: Maybe<Scalars['Float']>;
  capacity: Scalars['Float'];
  customerEnabled?: Maybe<Scalars['Boolean']>;
  datasheetUrl?: Maybe<Scalars['String']>;
  deletedAt?: Maybe<Scalars['Float']>;
  descriptionId?: Maybe<Scalars['Int']>;
  efficiency: Scalars['Float'];
  enabled?: Maybe<Scalars['Boolean']>;
  id: Scalars['Float'];
  imageUrl?: Maybe<Scalars['String']>;
  model: Scalars['String'];
  notes?: Maybe<Scalars['String']>;
  offerID?: Maybe<Scalars['Float']>;
  preferred?: Maybe<Scalars['Boolean']>;
  price: Scalars['Float'];
  quantity?: Maybe<Scalars['Int']>;
  size: HeatPumpSize;
  warrantyCycles?: Maybe<Scalars['Int']>;
  warrantyYears?: Maybe<Scalars['Int']>;
  webshopEnabled?: Maybe<Scalars['Boolean']>;
  weight: Scalars['Float'];
};

export type BatteryInput = {
  boxSize?: InputMaybe<BoxSizeInput>;
  brand: Scalars['String'];
  buyPrice?: InputMaybe<Scalars['Float']>;
  capacity: Scalars['Float'];
  customerEnabled?: InputMaybe<Scalars['Boolean']>;
  cylinderSize?: InputMaybe<CylinderSizeInput>;
  datasheetUrl?: InputMaybe<Scalars['String']>;
  deletedAt?: InputMaybe<Scalars['Float']>;
  descriptionId?: InputMaybe<Scalars['Int']>;
  efficiency: Scalars['Float'];
  enabled?: InputMaybe<Scalars['Boolean']>;
  imageUrl?: InputMaybe<Scalars['String']>;
  model: Scalars['String'];
  notes?: InputMaybe<Scalars['String']>;
  preferred?: InputMaybe<Scalars['Boolean']>;
  price: Scalars['Float'];
  warrantyCycles?: InputMaybe<Scalars['Int']>;
  warrantyYears?: InputMaybe<Scalars['Int']>;
  webshopEnabled?: InputMaybe<Scalars['Boolean']>;
  weight: Scalars['Float'];
};

export type BatteryProductRange = {
  batteries: Array<Battery>;
  id: Scalars['Int'];
  title: Scalars['String'];
};

export type BatteryRangeInput = {
  batteryIDs: Array<Scalars['Int']>;
  title: Scalars['String'];
};

export type BbrPrimaryHeating = {
  annualUsage: Scalars['Float'];
  efficiency?: Maybe<Scalars['Float']>;
  fuelSubtype?: Maybe<Scalars['String']>;
  fuelType: Scalars['String'];
  heatSource?: Maybe<Scalars['String']>;
  price?: Maybe<Scalars['Float']>;
  volumeUnit?: Maybe<Scalars['String']>;
};

export type BbrResidence = {
  area: Scalars['Float'];
  areaHeated: Scalars['Float'];
  areaNotHeated?: Maybe<Scalars['Int']>;
  areaPartiallyHeated?: Maybe<Scalars['Float']>;
  builtYear?: Maybe<Scalars['Float']>;
  consumption?: Maybe<Consumption>;
  energyExpenditure: Scalars['Float'];
  energyLabel?: Maybe<EnergyLabelEnum>;
  floors: Scalars['Float'];
  heatDistribution?: Maybe<HeatDistributionTypeEnum>;
  id?: Maybe<Scalars['Int']>;
  primaryHeating?: Maybe<BbrPrimaryHeating>;
  renovatedDegree?: Maybe<RenovationDegreeEnum>;
  renovatedYear?: Maybe<Scalars['Float']>;
  residents?: Maybe<Scalars['Float']>;
  roofs?: Maybe<Array<Roof>>;
  secondaryHeating?: Maybe<BbrSecondaryHeating>;
  type: ResidenceType;
  waterConsumption: WaterConsumptionDegreeEnum;
};

export type BbrSecondaryHeating = {
  heatSource?: Maybe<Scalars['String']>;
};

export type BoxSize = {
  depth: Scalars['Float'];
  height: Scalars['Float'];
  width: Scalars['Float'];
};

export type BoxSizeInput = {
  depth: Scalars['Float'];
  height: Scalars['Float'];
  width: Scalars['Float'];
};

export type CrmCustomer = {
  email?: Maybe<Scalars['String']>;
  firstName?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  lastName?: Maybe<Scalars['String']>;
  phoneNumber?: Maybe<Scalars['String']>;
};

export type CrmCustomerFields = {
  address?: Maybe<Scalars['String']>;
  assignedAdvisor?: Maybe<Scalars['String']>;
  financialAdvisor?: Maybe<Scalars['String']>;
  leadOrigin?: Maybe<Scalars['String']>;
  notes?: Maybe<Scalars['String']>;
};

export type CompositeFigure = {
  floor: Scalars['Float'];
  radiator: Scalars['Float'];
};

export type CompositeLabel = {
  floor: Scalars['String'];
  radiator: Scalars['String'];
};

export type Constant = {
  code: Scalars['String'];
  denominator?: Maybe<Scalars['String']>;
  id: Scalars['Int'];
  numerator: Scalars['String'];
  valueNumber: Scalars['Float'];
};

export type ConstantInput = {
  code: Scalars['String'];
  denominator?: InputMaybe<Scalars['String']>;
  numerator: Scalars['String'];
  valueNumber: Scalars['Float'];
};

export type Consumption = {
  profileKey: ConsumptionProfile;
  profileValue: Array<Scalars['Float']>;
};

export type ConsumptionProfile =
  | 'homeAt17'
  | 'homeEveryDay'
  | 'homeInAfternoon'
  | 'homeInMorning'
  | 'homeMostDays'
  | 'industrialConsumption';

export type Customer = {
  assignedAdvisor?: Maybe<User>;
  assignedAdvisorId?: Maybe<Scalars['Int']>;
  callBackAt?: Maybe<Scalars['Float']>;
  createdAt: Scalars['Float'];
  eligibleForFinancing: Scalars['Boolean'];
  email?: Maybe<Scalars['String']>;
  financialAdvisor?: Maybe<Scalars['String']>;
  financingProvider?: Maybe<CustomerFinancingProvider>;
  firstName?: Maybe<Scalars['String']>;
  id: Scalars['Int'];
  includeHeatPumpSubsidy?: Maybe<Scalars['Boolean']>;
  lastName?: Maybe<Scalars['String']>;
  leadOrigin?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  newsletter?: Maybe<Scalars['Boolean']>;
  norlysPromotion?: Maybe<Scalars['Boolean']>;
  notes?: Maybe<Scalars['String']>;
  numberOfOffers?: Maybe<Scalars['Int']>;
  ownerID?: Maybe<Scalars['Int']>;
  phoneNumber?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['Float']>;
  usePriceInflation?: Maybe<Scalars['Boolean']>;
};

export type CustomerFinancingProvider =
  | 'jyskebank'
  | 'nordea';

export type CustomerInput = {
  assignedAdvisorId?: InputMaybe<Scalars['Int']>;
  email?: InputMaybe<Scalars['String']>;
  financialAdvisor?: InputMaybe<Scalars['String']>;
  financingProvider?: InputMaybe<CustomerFinancingProvider>;
  firstName?: InputMaybe<Scalars['String']>;
  googleClickId?: InputMaybe<Scalars['String']>;
  includeHeatPumpSubsidy?: InputMaybe<Scalars['Boolean']>;
  lastName?: InputMaybe<Scalars['String']>;
  leadOrigin?: InputMaybe<Scalars['String']>;
  newsletter?: InputMaybe<Scalars['Boolean']>;
  norlysPromotion?: InputMaybe<Scalars['Boolean']>;
  notes?: InputMaybe<Scalars['String']>;
  phoneNumber?: InputMaybe<Scalars['String']>;
  scoringFields?: InputMaybe<ScoringFields>;
  usePriceInflation?: InputMaybe<Scalars['Boolean']>;
  utmFields?: InputMaybe<UtmFields>;
};

export type CylinderSize = {
  diameter: Scalars['Float'];
  height: Scalars['Float'];
};

export type CylinderSizeInput = {
  diameter: Scalars['Float'];
  height: Scalars['Float'];
};

export type DataConsentInput = {
  consented: Scalars['Boolean'];
  partner: DataConsentPartner;
};

export type DataConsentPartner =
  | 'edc'
  | 'jyskebank'
  | 'nordea'
  | 'norlys';

export type ElectricCar = {
  annualKilometersDriven: Scalars['Int'];
  consumptionPerKilometer: Scalars['Int'];
  id: Scalars['Int'];
  isSubsidised?: Maybe<Scalars['Boolean']>;
  monthlySubscriptionPrice?: Maybe<Scalars['Float']>;
  percentageCharged: Scalars['Int'];
};

export type ElectricCarInput = {
  annualKilometersDriven: Scalars['Int'];
  consumptionPerKilometer: Scalars['Int'];
  isSubsidised?: InputMaybe<Scalars['Boolean']>;
  monthlySubscriptionPrice?: InputMaybe<Scalars['Float']>;
  percentageCharged: Scalars['Int'];
};

export type EnergyLabelEnum =
  | 'A2010'
  | 'A2015'
  | 'A2020'
  | 'B'
  | 'C'
  | 'D'
  | 'E'
  | 'F'
  | 'G';

export type EnergyLabels = {
  before: Scalars['String'];
  both?: Maybe<Scalars['String']>;
  heatPump?: Maybe<Scalars['String']>;
  solar?: Maybe<Scalars['String']>;
};

export type FuelType =
  | 'districtHeating'
  | 'electricity'
  | 'gas'
  | 'oil'
  | 'pallet'
  | 'straw'
  | 'wood';

export type HeatDistributionTypeEnum =
  | 'floor'
  | 'radiator'
  | 'radiatorAndFloor';

export type HeatPumpApp =
  | 'addition'
  | 'nibe'
  | 'unknown'
  | 'yes';

export type HeatPumpIndoorUnit = {
  app: HeatPumpApp;
  brand: Scalars['String'];
  buffer: Scalars['Float'];
  buyPrice?: Maybe<Scalars['Float']>;
  customerEnabled?: Maybe<Scalars['Boolean']>;
  datasheetUrl?: Maybe<Scalars['String']>;
  deletedAt?: Maybe<Scalars['Float']>;
  descriptionId?: Maybe<Scalars['Int']>;
  enabled?: Maybe<Scalars['Boolean']>;
  id: Scalars['Float'];
  imageUrl?: Maybe<Scalars['String']>;
  internet: HeatPumpInternet;
  model: Scalars['String'];
  noiseLevel: Scalars['Float'];
  notes?: Maybe<Scalars['String']>;
  offerID?: Maybe<Scalars['Float']>;
  power?: Maybe<Scalars['String']>;
  preferred?: Maybe<Scalars['Boolean']>;
  price: Scalars['Float'];
  quantity?: Maybe<Scalars['Int']>;
  size: HeatPumpSize;
  solutionType: IndoorUnitSolutionType;
  waterVolume: Scalars['Float'];
  webshopEnabled?: Maybe<Scalars['Boolean']>;
};

export type HeatPumpIndoorUnitInput = {
  app: HeatPumpApp;
  boxSize?: InputMaybe<BoxSizeInput>;
  brand: Scalars['String'];
  buffer: Scalars['Float'];
  buyPrice?: InputMaybe<Scalars['Float']>;
  customerEnabled?: InputMaybe<Scalars['Boolean']>;
  cylinderSize?: InputMaybe<CylinderSizeInput>;
  datasheetUrl?: InputMaybe<Scalars['String']>;
  deletedAt?: InputMaybe<Scalars['Float']>;
  descriptionId?: InputMaybe<Scalars['Int']>;
  enabled?: InputMaybe<Scalars['Boolean']>;
  imageUrl?: InputMaybe<Scalars['String']>;
  internet: HeatPumpInternet;
  model: Scalars['String'];
  noiseLevel: Scalars['Float'];
  notes?: InputMaybe<Scalars['String']>;
  power?: InputMaybe<Scalars['String']>;
  preferred?: InputMaybe<Scalars['Boolean']>;
  price: Scalars['Float'];
  solutionType?: InputMaybe<IndoorUnitSolutionType>;
  waterVolume: Scalars['Float'];
  webshopEnabled?: InputMaybe<Scalars['Boolean']>;
};

export type HeatPumpInternet =
  | 'LAN'
  | 'unknown'
  | 'wifi'
  | 'wifiAddition';

export type HeatPumpOfferInput = {
  chosenHeating?: InputMaybe<Scalars['Float']>;
  discount?: InputMaybe<Scalars['Int']>;
  discountWithoutInstallation?: InputMaybe<Scalars['Int']>;
  expenses?: InputMaybe<Array<OfferExpenseInput>>;
  heatPumpIndoorProduct?: InputMaybe<ProductInput>;
  heatPumpOutdoorProduct?: InputMaybe<ProductInput>;
  notes?: InputMaybe<Scalars['String']>;
  reservations?: InputMaybe<Scalars['String']>;
  withoutInstallation?: InputMaybe<Scalars['Boolean']>;
};

export type HeatPumpOutdoorUnit = {
  brand: Scalars['String'];
  buyPrice?: Maybe<Scalars['Float']>;
  compatibleIndoorUnits: Array<Scalars['Int']>;
  copHotWater?: Maybe<Scalars['Float']>;
  customerEnabled?: Maybe<Scalars['Boolean']>;
  datasheetUrl?: Maybe<Scalars['String']>;
  deletedAt?: Maybe<Scalars['Float']>;
  descriptionId?: Maybe<Scalars['Int']>;
  effect7: CompositeFigure;
  effect12: CompositeFigure;
  enabled?: Maybe<Scalars['Boolean']>;
  energyLabel: CompositeLabel;
  id: Scalars['Float'];
  imageUrl?: Maybe<Scalars['String']>;
  model: Scalars['String'];
  noiseLevel: Scalars['Float'];
  notes?: Maybe<Scalars['String']>;
  offerID?: Maybe<Scalars['Float']>;
  preferred?: Maybe<Scalars['Boolean']>;
  price: Scalars['Float'];
  quantity?: Maybe<Scalars['Int']>;
  scop: CompositeFigure;
  size: HeatPumpSize;
  temperatureOut: Scalars['Int'];
  waterLabel: Scalars['String'];
  webshopEnabled?: Maybe<Scalars['Boolean']>;
};

export type HeatPumpOutdoorUnitInput = {
  boxSize?: InputMaybe<BoxSizeInput>;
  brand: Scalars['String'];
  buyPrice?: InputMaybe<Scalars['Float']>;
  compatibleIndoorUnits: Array<Scalars['Int']>;
  copHotWater: Scalars['Float'];
  customerEnabled?: InputMaybe<Scalars['Boolean']>;
  cylinderSize?: InputMaybe<CylinderSizeInput>;
  datasheetUrl?: InputMaybe<Scalars['String']>;
  deletedAt?: InputMaybe<Scalars['Float']>;
  descriptionId?: InputMaybe<Scalars['Int']>;
  effectFloor7: Scalars['Float'];
  effectFloor12: Scalars['Float'];
  effectRadiator7: Scalars['Float'];
  effectRadiator12: Scalars['Float'];
  enabled?: InputMaybe<Scalars['Boolean']>;
  energyLabelFloor: Scalars['String'];
  energyLabelRadiator: Scalars['String'];
  imageUrl?: InputMaybe<Scalars['String']>;
  model: Scalars['String'];
  noiseLevel: Scalars['Float'];
  notes?: InputMaybe<Scalars['String']>;
  preferred?: InputMaybe<Scalars['Boolean']>;
  price: Scalars['Float'];
  scopFloor: Scalars['Float'];
  scopRadiator: Scalars['Float'];
  temperatureOut: Scalars['Int'];
  waterLabel: Scalars['String'];
  webshopEnabled?: InputMaybe<Scalars['Boolean']>;
};

export type HeatPumpPackageInput = {
  calculatorEnabled?: InputMaybe<Scalars['Boolean']>;
  discount?: InputMaybe<Scalars['Float']>;
  indoorUnitID?: InputMaybe<Scalars['Int']>;
  outdoorUnitID: Scalars['Int'];
  title: Scalars['String'];
  webshopEnabled?: InputMaybe<Scalars['Boolean']>;
};

export type HeatPumpProductPackage = {
  calculatorEnabled?: Maybe<Scalars['Boolean']>;
  discount?: Maybe<Scalars['Float']>;
  indoorUnits?: Maybe<Array<HeatPumpIndoorUnit>>;
  outdoorUnits: Array<HeatPumpOutdoorUnit>;
  packageID: Scalars['Int'];
  title?: Maybe<Scalars['String']>;
  webshopEnabled?: Maybe<Scalars['Boolean']>;
};

export type HeatPumpSize = BoxSize | CylinderSize;

export type HeatingPriority =
  | 'primary'
  | 'secondary';

export type HeatingSource =
  | 'districtHeating'
  | 'electricity'
  | 'gas'
  | 'heatPump'
  | 'oil'
  | 'other';

export type HouseInput = {
  annualPrice: Scalars['Float'];
  fuelType: FuelType;
};

export type HouseInputWithUsage = {
  annualUsage: Scalars['Float'];
  electricCar?: InputMaybe<ElectricCarInput>;
  energyExpenditure?: InputMaybe<Scalars['Float']>;
  fuelType: FuelType;
};

export type Image = {
  category?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  residenceID?: Maybe<Scalars['Int']>;
  url: Scalars['String'];
};

export type IndoorUnitSolutionType =
  | 'mono'
  | 'split';

export type InterestedInAdvice =
  | 'no'
  | 'yes';

export type Inverter = {
  brand: Scalars['String'];
  buyPrice?: Maybe<Scalars['Float']>;
  capacity: Scalars['Float'];
  compatibleBatteries?: Maybe<Array<Scalars['Int']>>;
  customerEnabled?: Maybe<Scalars['Boolean']>;
  datasheetUrl?: Maybe<Scalars['String']>;
  deletedAt?: Maybe<Scalars['Float']>;
  descriptionId?: Maybe<Scalars['Int']>;
  efficiency: Scalars['Float'];
  enabled?: Maybe<Scalars['Boolean']>;
  id: Scalars['Float'];
  imageUrl?: Maybe<Scalars['String']>;
  model: Scalars['String'];
  notes?: Maybe<Scalars['String']>;
  offerID?: Maybe<Scalars['Float']>;
  preferred?: Maybe<Scalars['Boolean']>;
  price: Scalars['Float'];
  quantity?: Maybe<Scalars['Int']>;
  size: HeatPumpSize;
  warrantyYears: Scalars['Int'];
  webshopEnabled?: Maybe<Scalars['Boolean']>;
  weight: Scalars['Float'];
};

export type InverterInput = {
  boxSize?: InputMaybe<BoxSizeInput>;
  brand: Scalars['String'];
  buyPrice?: InputMaybe<Scalars['Float']>;
  capacity: Scalars['Float'];
  compatibleBatteries?: InputMaybe<Array<Scalars['Int']>>;
  customerEnabled?: InputMaybe<Scalars['Boolean']>;
  cylinderSize?: InputMaybe<CylinderSizeInput>;
  datasheetUrl?: InputMaybe<Scalars['String']>;
  deletedAt?: InputMaybe<Scalars['Float']>;
  descriptionId?: InputMaybe<Scalars['Int']>;
  efficiency: Scalars['Float'];
  enabled?: InputMaybe<Scalars['Boolean']>;
  imageUrl?: InputMaybe<Scalars['String']>;
  model: Scalars['String'];
  notes?: InputMaybe<Scalars['String']>;
  preferred?: InputMaybe<Scalars['Boolean']>;
  price: Scalars['Float'];
  warrantyYears: Scalars['Int'];
  webshopEnabled?: InputMaybe<Scalars['Boolean']>;
  weight: Scalars['Float'];
};

export type InvestmentTime =
  | 'laterThan3Months'
  | 'undecided'
  | 'within3Months';

export type LeadProductTypeEnum =
  | 'heatPump'
  | 'other'
  | 'solar';

export type LoginResult = {
  accessToken: Scalars['String'];
  refreshToken: Scalars['String'];
  user: User;
};

export type MonthlyConsumption = {
  profileKey: MonthlyConsumptionProfile;
  profileValue: Array<Scalars['Float']>;
};

export type MonthlyConsumptionProfile =
  | 'industrial'
  | 'privateDomicile';

export type Mutation = {
  addCustomerLead: Scalars['Boolean'];
  archiveOffer: Scalars['Boolean'];
  callMe: Scalars['Boolean'];
  contactMe: Scalars['Boolean'];
  copyOffer: Offer;
  createBatteryRange: BatteryProductRange;
  createConstant: Constant;
  createHeatPumpPackage: HeatPumpProductPackage;
  createProductDescription: ProductDescription;
  createSolarProductPackage?: Maybe<SolarProductPackage>;
  deleteAssortedProductDatasheet: Scalars['Boolean'];
  deleteBatteryDatasheet: Scalars['Boolean'];
  deleteBatteryRange: Scalars['Boolean'];
  deleteElectricCar: Scalars['Boolean'];
  deleteExpenseTemplate: Scalars['Boolean'];
  deleteHeatPumpIndoorUnitDatasheet: Scalars['Boolean'];
  deleteHeatPumpOutdoorUnitDatasheet: Scalars['Boolean'];
  deleteHeatPumpPackage: Scalars['Boolean'];
  deleteInverterDatasheet: Scalars['Boolean'];
  deleteOfferExpenses: Scalars['Boolean'];
  deleteProductDescription: Scalars['Boolean'];
  deleteResidenceImage: Scalars['Boolean'];
  deleteSiteVisitFile: Scalars['Boolean'];
  deleteSolarPanelDatasheet: Scalars['Boolean'];
  deleteSolarProductPackage: Scalars['Boolean'];
  forgotPassword: Scalars['String'];
  hardDeleteCustomer: Scalars['Boolean'];
  insertAndSendOffers: Scalars['Boolean'];
  insertAssortedProduct?: Maybe<AssortedProduct>;
  insertBattery?: Maybe<Battery>;
  insertHeatPumpIndoorUnit?: Maybe<HeatPumpIndoorUnit>;
  insertHeatPumpOutdoorUnit?: Maybe<HeatPumpOutdoorUnit>;
  insertInverter?: Maybe<Inverter>;
  insertOffers: Array<Offer>;
  insertSolarPanel?: Maybe<SolarPanel>;
  login: LoginResult;
  logout: Scalars['Boolean'];
  markOfferAsSent: Scalars['Boolean'];
  refreshLogin: LoginResult;
  regeneratePreview: Scalars['String'];
  register: User;
  registerLead: Scalars['Boolean'];
  removeConstant: Scalars['Boolean'];
  resendVerificationEmail: Scalars['String'];
  setOfferExpenses: Array<OfferExpense>;
  setResidenceRoofType: Scalars['Boolean'];
  syncContactInformationWithCRM: Scalars['Boolean'];
  syncOfferExpenses: Offer;
  syncOfferInformationWithCRM: Scalars['Boolean'];
  syncProductsWithWebshop: Scalars['Boolean'];
  unarchiveOffer: Scalars['Boolean'];
  unregister: Scalars['Boolean'];
  updateAssortedProduct?: Maybe<AssortedProduct>;
  updateAssortedProductImage: Scalars['String'];
  updateBattery?: Maybe<Battery>;
  updateBatteryImage: Scalars['String'];
  updateBatteryRange: BatteryProductRange;
  updateConstant: Constant;
  updateHeatPumpIndoorImage: Scalars['String'];
  updateHeatPumpIndoorUnit?: Maybe<HeatPumpIndoorUnit>;
  updateHeatPumpOutdoorImage: Scalars['String'];
  updateHeatPumpOutdoorUnit?: Maybe<HeatPumpOutdoorUnit>;
  updateHeatPumpPackage: HeatPumpProductPackage;
  updateInverter?: Maybe<Inverter>;
  updateInverterImage: Scalars['String'];
  updateOfferNotes: Offer;
  updateOfferProductPrice: Offer;
  updatePassword: Scalars['Boolean'];
  updateProductDescription: ProductDescription;
  updateSolarPanel?: Maybe<SolarPanel>;
  updateSolarPanelImage: Scalars['String'];
  updateSolarProductPackage?: Maybe<SolarProductPackage>;
  updateUser?: Maybe<User>;
  uploadAssortedProductDatasheet: Scalars['Boolean'];
  uploadBatteryDatasheet: Scalars['Boolean'];
  uploadHeatPumpIndoorUnitDatasheet: Scalars['Boolean'];
  uploadHeatPumpOutdoorUnitDatasheet: Scalars['Boolean'];
  uploadInverterDatasheet: Scalars['Boolean'];
  uploadPublicFile: Scalars['String'];
  uploadResidenceImages: Array<Image>;
  uploadSiteVisitFile: Scalars['String'];
  uploadSolarPanelDatasheet: Scalars['Boolean'];
  upsertCustomer: Customer;
  upsertExpenseTemplate: OfferExpenseTemplate;
  upsertReservation: Offer;
  upsertResidence: Residence;
  upsertSiteVisitAnswerList: Scalars['Boolean'];
};


export type MutationAddCustomerLeadArgs = {
  customer: BankCustomerLead;
};


export type MutationArchiveOfferArgs = {
  id: Scalars['Int'];
};


export type MutationCallMeArgs = {
  address?: InputMaybe<Scalars['String']>;
  leadOrigin?: InputMaybe<Scalars['String']>;
  name: Scalars['String'];
  phoneNumber: Scalars['String'];
};


export type MutationContactMeArgs = {
  email: Scalars['String'];
  inquiry?: InputMaybe<Scalars['String']>;
  isCompany?: InputMaybe<Scalars['Boolean']>;
  name: Scalars['String'];
  phoneNumber?: InputMaybe<Scalars['String']>;
};


export type MutationCopyOfferArgs = {
  archiveExisting?: InputMaybe<Scalars['Boolean']>;
  existingOfferID: Scalars['Int'];
  offer: OfferInput;
};


export type MutationCreateBatteryRangeArgs = {
  batteryRangeInput: BatteryRangeInput;
};


export type MutationCreateConstantArgs = {
  constant: ConstantInput;
};


export type MutationCreateHeatPumpPackageArgs = {
  heatPumpPackageInput?: InputMaybe<HeatPumpPackageInput>;
};


export type MutationCreateProductDescriptionArgs = {
  description: ProductDescriptionInput;
};


export type MutationCreateSolarProductPackageArgs = {
  solarPackageInput?: InputMaybe<SolarProductPackageInput>;
};


export type MutationDeleteAssortedProductDatasheetArgs = {
  id: Scalars['Int'];
};


export type MutationDeleteBatteryDatasheetArgs = {
  id: Scalars['Int'];
};


export type MutationDeleteBatteryRangeArgs = {
  id: Scalars['Int'];
};


export type MutationDeleteElectricCarArgs = {
  residenceID: Scalars['Int'];
};


export type MutationDeleteExpenseTemplateArgs = {
  templateID: Scalars['Int'];
};


export type MutationDeleteHeatPumpIndoorUnitDatasheetArgs = {
  id: Scalars['Int'];
};


export type MutationDeleteHeatPumpOutdoorUnitDatasheetArgs = {
  id: Scalars['Int'];
};


export type MutationDeleteHeatPumpPackageArgs = {
  id: Scalars['Int'];
};


export type MutationDeleteInverterDatasheetArgs = {
  id: Scalars['Int'];
};


export type MutationDeleteOfferExpensesArgs = {
  expenseIds: Array<Scalars['Int']>;
  offerId: Scalars['Int'];
};


export type MutationDeleteProductDescriptionArgs = {
  id: Scalars['Int'];
};


export type MutationDeleteResidenceImageArgs = {
  code?: InputMaybe<Scalars['String']>;
  imageUrl: Scalars['String'];
  residenceID: Scalars['Int'];
};


export type MutationDeleteSiteVisitFileArgs = {
  code?: InputMaybe<Scalars['String']>;
  id: Scalars['Int'];
};


export type MutationDeleteSolarPanelDatasheetArgs = {
  id: Scalars['Int'];
};


export type MutationDeleteSolarProductPackageArgs = {
  id: Scalars['Int'];
};


export type MutationForgotPasswordArgs = {
  email: Scalars['String'];
};


export type MutationHardDeleteCustomerArgs = {
  id: Scalars['Int'];
};


export type MutationInsertAndSendOffersArgs = {
  address: AddressInput;
  customer: CustomerInput;
  dataConsent?: InputMaybe<DataConsentInput>;
  heatPumpOffers?: InputMaybe<Array<HeatPumpOfferInput>>;
  residence: ResidenceInput;
  solarOffers?: InputMaybe<Array<SolarOfferInput>>;
};


export type MutationInsertAssortedProductArgs = {
  unit: AssortedProductInput;
};


export type MutationInsertBatteryArgs = {
  unit: BatteryInput;
};


export type MutationInsertHeatPumpIndoorUnitArgs = {
  unit: HeatPumpIndoorUnitInput;
};


export type MutationInsertHeatPumpOutdoorUnitArgs = {
  unit: HeatPumpOutdoorUnitInput;
};


export type MutationInsertInverterArgs = {
  unit: InverterInput;
};


export type MutationInsertOffersArgs = {
  address?: InputMaybe<AddressInput>;
  assortedOffers?: InputMaybe<Array<AssortedOfferInput>>;
  customerID?: InputMaybe<Scalars['Int']>;
  email?: InputMaybe<Scalars['String']>;
  heatPumpOffers?: InputMaybe<Array<HeatPumpOfferInput>>;
  residenceID?: InputMaybe<Scalars['Int']>;
  solarOffers?: InputMaybe<Array<SolarOfferInput>>;
};


export type MutationInsertSolarPanelArgs = {
  unit: SolarPanelInput;
};


export type MutationLoginArgs = {
  email: Scalars['String'];
  password: Scalars['String'];
};


export type MutationLogoutArgs = {
  refreshToken: Scalars['String'];
};


export type MutationMarkOfferAsSentArgs = {
  offerID: Scalars['Int'];
  type: OfferPdfTypeEnum;
};


export type MutationRefreshLoginArgs = {
  refreshToken: Scalars['String'];
};


export type MutationRegeneratePreviewArgs = {
  offerID: Scalars['Int'];
  type: OfferPdfTypeEnum;
};


export type MutationRegisterArgs = {
  user: RegisterUserInput;
};


export type MutationRegisterLeadArgs = {
  address: AddressInput;
  customer: CustomerInput;
};


export type MutationRemoveConstantArgs = {
  code: Scalars['String'];
};


export type MutationSetOfferExpensesArgs = {
  expenses: Array<OfferExpenseInput>;
  offerID: Scalars['Int'];
};


export type MutationSetResidenceRoofTypeArgs = {
  residenceId: Scalars['Int'];
  roofType: RoofType;
};


export type MutationSyncContactInformationWithCrmArgs = {
  residenceId: Scalars['Int'];
};


export type MutationSyncOfferExpensesArgs = {
  offerID: Scalars['Int'];
};


export type MutationSyncOfferInformationWithCrmArgs = {
  offerId: Scalars['Int'];
};


export type MutationUnarchiveOfferArgs = {
  id: Scalars['Int'];
};


export type MutationUnregisterArgs = {
  id: Scalars['Int'];
};


export type MutationUpdateAssortedProductArgs = {
  id: Scalars['Int'];
  unit: AssortedProductInput;
};


export type MutationUpdateAssortedProductImageArgs = {
  id: Scalars['Int'];
  image: Scalars['Upload'];
};


export type MutationUpdateBatteryArgs = {
  id: Scalars['Int'];
  unit: BatteryInput;
};


export type MutationUpdateBatteryImageArgs = {
  id: Scalars['Int'];
  image: Scalars['Upload'];
};


export type MutationUpdateBatteryRangeArgs = {
  batteryRangeInput: BatteryRangeInput;
  id: Scalars['Int'];
};


export type MutationUpdateConstantArgs = {
  constant: ConstantInput;
};


export type MutationUpdateHeatPumpIndoorImageArgs = {
  id: Scalars['Int'];
  image: Scalars['Upload'];
};


export type MutationUpdateHeatPumpIndoorUnitArgs = {
  id: Scalars['Int'];
  unit: HeatPumpIndoorUnitInput;
};


export type MutationUpdateHeatPumpOutdoorImageArgs = {
  id: Scalars['Int'];
  image: Scalars['Upload'];
};


export type MutationUpdateHeatPumpOutdoorUnitArgs = {
  id: Scalars['Int'];
  unit: HeatPumpOutdoorUnitInput;
};


export type MutationUpdateHeatPumpPackageArgs = {
  heatPumpPackageInput: HeatPumpPackageInput;
  id: Scalars['Int'];
};


export type MutationUpdateInverterArgs = {
  id: Scalars['Int'];
  unit: InverterInput;
};


export type MutationUpdateInverterImageArgs = {
  id: Scalars['Int'];
  image: Scalars['Upload'];
};


export type MutationUpdateOfferNotesArgs = {
  notes: Scalars['String'];
  offerID: Scalars['Int'];
};


export type MutationUpdateOfferProductPriceArgs = {
  offerID: Scalars['Int'];
  price: Scalars['Float'];
  type: OfferProductType;
  unitID: Scalars['Int'];
};


export type MutationUpdatePasswordArgs = {
  code: Scalars['String'];
  password: Scalars['String'];
};


export type MutationUpdateProductDescriptionArgs = {
  description: ProductDescriptionInput;
  id: Scalars['Int'];
};


export type MutationUpdateSolarPanelArgs = {
  id: Scalars['Int'];
  unit: SolarPanelInput;
};


export type MutationUpdateSolarPanelImageArgs = {
  id: Scalars['Int'];
  image: Scalars['Upload'];
};


export type MutationUpdateSolarProductPackageArgs = {
  id: Scalars['Int'];
  solarPackageInput: SolarProductPackageInput;
};


export type MutationUpdateUserArgs = {
  user: UpdateUserInput;
};


export type MutationUploadAssortedProductDatasheetArgs = {
  datasheet: Scalars['Upload'];
  id: Scalars['Int'];
};


export type MutationUploadBatteryDatasheetArgs = {
  datasheet: Scalars['Upload'];
  id: Scalars['Int'];
};


export type MutationUploadHeatPumpIndoorUnitDatasheetArgs = {
  datasheet: Scalars['Upload'];
  id: Scalars['Int'];
};


export type MutationUploadHeatPumpOutdoorUnitDatasheetArgs = {
  datasheet: Scalars['Upload'];
  id: Scalars['Int'];
};


export type MutationUploadInverterDatasheetArgs = {
  datasheet: Scalars['Upload'];
  id: Scalars['Int'];
};


export type MutationUploadPublicFileArgs = {
  file: Scalars['Upload'];
};


export type MutationUploadResidenceImagesArgs = {
  category?: InputMaybe<Scalars['String']>;
  code?: InputMaybe<Scalars['String']>;
  id: Scalars['Int'];
  images: Array<Scalars['Upload']>;
};


export type MutationUploadSiteVisitFileArgs = {
  code?: InputMaybe<Scalars['String']>;
  file: Scalars['Upload'];
  offerID: Scalars['Int'];
};


export type MutationUploadSolarPanelDatasheetArgs = {
  datasheet: Scalars['Upload'];
  id: Scalars['Int'];
};


export type MutationUpsertCustomerArgs = {
  customer: CustomerInput;
  id?: InputMaybe<Scalars['Int']>;
};


export type MutationUpsertExpenseTemplateArgs = {
  template: OfferExpenseTemplateInput;
};


export type MutationUpsertReservationArgs = {
  offerID: Scalars['Int'];
  reservation: Scalars['String'];
};


export type MutationUpsertResidenceArgs = {
  customerID?: InputMaybe<Scalars['Int']>;
  customerInput?: InputMaybe<CustomerInput>;
  email?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  residence: ResidenceInput;
};


export type MutationUpsertSiteVisitAnswerListArgs = {
  answerList: Array<SiteVisitAnswerInput>;
  code?: InputMaybe<Scalars['String']>;
};

export type NewOfferExpenses = {
  heatPump: Array<OfferExpenseTemplate>;
  solar: Array<OfferExpenseTemplate>;
};

export type Offer = {
  address?: Maybe<Address>;
  assortedProducts?: Maybe<Array<AssortedProduct>>;
  battery?: Maybe<Battery>;
  batteryProduct?: Maybe<Product>;
  chosenHeating?: Maybe<Scalars['Float']>;
  createdAt?: Maybe<Scalars['Float']>;
  customer?: Maybe<Customer>;
  deletedAt?: Maybe<Scalars['Float']>;
  expenses?: Maybe<Array<OfferExpense>>;
  finalPreview: Scalars['String'];
  heatPumpIndoorProduct?: Maybe<Product>;
  heatPumpIndoorUnit?: Maybe<HeatPumpIndoorUnit>;
  heatPumpOutdoorProduct?: Maybe<Product>;
  heatPumpOutdoorUnit?: Maybe<HeatPumpOutdoorUnit>;
  id: Scalars['Int'];
  installationAccessCode: Scalars['String'];
  inverter?: Maybe<Inverter>;
  inverterProduct?: Maybe<Product>;
  notes?: Maybe<Scalars['String']>;
  preferred?: Maybe<Scalars['Boolean']>;
  preliminaryPreview: Scalars['String'];
  price?: Maybe<Scalars['Float']>;
  reservations?: Maybe<Scalars['String']>;
  residence?: Maybe<Residence>;
  residenceID: Scalars['Int'];
  sentOffers?: Maybe<Array<OfferDispatch>>;
  siteVisitAccessCode: Scalars['String'];
  solarPanel?: Maybe<SolarPanel>;
  solarPanelProduct?: Maybe<Product>;
  tag: Scalars['String'];
  updatedAt?: Maybe<Scalars['Float']>;
};

export type OfferActor =
  | 'advisor'
  | 'customer';

export type OfferDispatch = {
  id: Scalars['Int'];
  sentAt?: Maybe<Scalars['Float']>;
  type?: Maybe<OfferPdfTypeEnum>;
};

export type OfferExpense = {
  buyPrice: Scalars['Float'];
  description?: Maybe<Scalars['String']>;
  id: Scalars['Int'];
  includedByDefault?: Maybe<Scalars['Boolean']>;
  notes?: Maybe<Scalars['String']>;
  offerID: Scalars['Int'];
  price: Scalars['Float'];
  quantity: Scalars['Int'];
  templateID?: Maybe<Scalars['Int']>;
  title?: Maybe<Scalars['String']>;
  type?: Maybe<OfferExpenseType>;
};

export type OfferExpenseInput = {
  buyPrice: Scalars['Float'];
  description?: InputMaybe<Scalars['String']>;
  notes?: InputMaybe<Scalars['String']>;
  price: Scalars['Float'];
  quantity?: InputMaybe<Scalars['Int']>;
  templateID?: InputMaybe<Scalars['Int']>;
  title?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<OfferExpenseType>;
};

export type OfferExpenseTemplate = {
  buyPrice: Scalars['Float'];
  createdAt: Scalars['Float'];
  denominator?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  id: Scalars['Int'];
  includedByDefault?: Maybe<Scalars['Boolean']>;
  locked?: Maybe<Scalars['Boolean']>;
  minimumProducts?: Maybe<Scalars['Int']>;
  offerType?: Maybe<OfferType>;
  price: Scalars['Float'];
  title: Scalars['String'];
  type: OfferExpenseTemplateType;
  updatedAt?: Maybe<Scalars['Float']>;
};

export type OfferExpenseTemplateInput = {
  buyPrice: Scalars['Float'];
  denominator?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  includedByDefault?: InputMaybe<Scalars['Boolean']>;
  offerType: OfferType;
  price: Scalars['Float'];
  title: Scalars['String'];
  type: OfferExpenseTemplateType;
};

export type OfferExpenseTemplateType =
  | 'batteryInstallation'
  | 'indoorUnitInstallation'
  | 'inverterInstallation'
  | 'nonPhysical'
  | 'outdoorUnitInstallation'
  | 'physical'
  | 'solarPanelInstallation';

export type OfferExpenseType =
  | 'installation'
  | 'nonPhysical'
  | 'physical';

export type OfferInput = {
  assortedProducts?: InputMaybe<Array<ProductInput>>;
  batteryProduct?: InputMaybe<ProductInput>;
  chosenHeating?: InputMaybe<Scalars['Float']>;
  discount?: InputMaybe<Scalars['Int']>;
  discountWithoutInstallation?: InputMaybe<Scalars['Int']>;
  expenses?: InputMaybe<Array<OfferExpenseInput>>;
  heatPumpIndoorProduct?: InputMaybe<ProductInput>;
  heatPumpOutdoorProduct?: InputMaybe<ProductInput>;
  inverterProduct?: InputMaybe<ProductInput>;
  notes?: InputMaybe<Scalars['String']>;
  reservations?: InputMaybe<Scalars['String']>;
  solarPanelProduct?: InputMaybe<ProductInput>;
  withoutInstallation?: InputMaybe<Scalars['Boolean']>;
};

export type OfferPdfTypeEnum =
  | 'final'
  | 'preliminary';

export type OfferProductType =
  | 'assorted'
  | 'battery'
  | 'heatPumpIndoorUnit'
  | 'heatPumpOutdoorUnit'
  | 'inverter'
  | 'solarPanel';

export type OfferProducts = {
  battery?: Maybe<Battery>;
  expenses?: Maybe<Array<OfferExpense>>;
  heatPumpIndoorUnit?: Maybe<HeatPumpIndoorUnit>;
  heatPumpOutdoorUnit?: Maybe<HeatPumpOutdoorUnit>;
  inverter?: Maybe<Inverter>;
  price?: Maybe<Scalars['Float']>;
  solarPackageDiscount?: Maybe<Scalars['Int']>;
  solarPackageId?: Maybe<Scalars['Int']>;
  solarPanel?: Maybe<SolarPanel>;
};

export type OfferSavings = {
  after: ProductUsage;
  before: ProductUsage;
  saved: OfferTotalSaved;
};

export type OfferSavingsWithProducts = {
  disclaimer: Scalars['String'];
  investment: Scalars['Float'];
  paybackMonths: Scalars['Float'];
  products: OfferProducts;
  residence?: Maybe<SimpleResidenceResult>;
  savings: OfferSavings;
  types: Array<OfferType>;
};

export type OfferTotalSaved = {
  emission: Scalars['Float'];
  price: Scalars['Float'];
  priceByYear: Array<Scalars['Float']>;
};

export type OfferType =
  | 'assorted'
  | 'heatPump'
  | 'solar';

export type OffersWithCount = {
  count: Scalars['Int'];
  offers: Array<Offer>;
};

export type PanelCategory =
  | 'builtIn'
  | 'freeStanding';

export type PanelType =
  | 'monoCrystal'
  | 'polyCrystal';

export type PartialResidenceInput = {
  addressID?: InputMaybe<Scalars['Float']>;
  area?: InputMaybe<Scalars['Float']>;
  areaHeated?: InputMaybe<Scalars['Float']>;
  areaNotHeated?: InputMaybe<Scalars['Float']>;
  areaPartiallyHeated?: InputMaybe<Scalars['Float']>;
  customerID?: InputMaybe<Scalars['Float']>;
  electricCar?: InputMaybe<ElectricCarInput>;
  energyExpenditure?: InputMaybe<Scalars['Float']>;
  energyLabel?: InputMaybe<EnergyLabelEnum>;
  heatDistribution?: InputMaybe<HeatDistributionTypeEnum>;
  primaryHeating?: InputMaybe<ResidenceHeatingInput>;
  radiatorFloorPercentage?: InputMaybe<Scalars['Float']>;
  roofs?: InputMaybe<Array<RoofInput>>;
  secondaryHeating?: InputMaybe<ResidenceHeatingInput>;
  type?: InputMaybe<ResidenceType>;
};

export type Product = {
  id: Scalars['Int'];
  price?: Maybe<Scalars['Float']>;
  quantity?: Maybe<Scalars['Int']>;
};

export type ProductDescription = {
  content: Scalars['String'];
  id: Scalars['Int'];
  title: Scalars['String'];
  type: OfferProductType;
};

export type ProductDescriptionInput = {
  content: Scalars['String'];
  title: Scalars['String'];
  type: OfferProductType;
};

export type ProductInput = {
  buyPrice?: InputMaybe<Scalars['Float']>;
  id: Scalars['Int'];
  price?: InputMaybe<Scalars['Float']>;
  quantity?: InputMaybe<Scalars['Int']>;
};

export type ProductUsage = {
  bought: Scalars['Float'];
  boughtPrice?: Maybe<Scalars['Float']>;
  consumptionPerMonth?: Maybe<Array<Scalars['Float']>>;
  domesticDiscount: Scalars['Float'];
  domesticPrice: Scalars['Float'];
  electricityDiscount?: Maybe<Scalars['Float']>;
  fuelPrice?: Maybe<Scalars['Float']>;
  netEarning?: Maybe<Scalars['Float']>;
  netSpentElectricity?: Maybe<Scalars['Float']>;
  produced: Scalars['Float'];
  productionPerMonth?: Maybe<Array<Scalars['Float']>>;
  sold: Scalars['Float'];
  soldPrice?: Maybe<Scalars['Float']>;
  totalEmission?: Maybe<Scalars['Float']>;
  totalPrice: Scalars['Float'];
  used: Scalars['Float'];
  usedPercentage?: Maybe<Scalars['Float']>;
};

export type Query = {
  addressSavings: AllOfferSavings;
  allOfferTypeSavings: Array<OfferSavingsWithProducts>;
  assortedProduct?: Maybe<AssortedProduct>;
  assortedProductBrands: Array<Scalars['String']>;
  assortedProducts: Array<AssortedProduct>;
  batteries: Array<Battery>;
  battery?: Maybe<Battery>;
  batteryBrands: Array<Scalars['String']>;
  batteryRanges: Array<BatteryProductRange>;
  bbrLookupByAddress?: Maybe<BbrResidence>;
  bbrLookupByDawaId?: Maybe<BbrResidence>;
  bodilAdvisors: Array<User>;
  calculateAddressSavings: AllOfferSavings;
  calculateAddressSavingsLokalBolig: AllOfferSavings;
  calculateEnergyLabels: EnergyLabels;
  calculateOfferSavings: OfferSavings;
  calculateOfferTypeSavings: OfferSavingsWithProducts;
  constants: Array<Constant>;
  constantsWithPartialCode: Array<Constant>;
  crmCustomerFieldValues?: Maybe<CrmCustomerFields>;
  customer?: Maybe<Customer>;
  dashboardOffers: OffersWithCount;
  energyLabel?: Maybe<EnergyLabelEnum>;
  energyOptions: Array<Constant>;
  expenseTemplates: Array<OfferExpenseTemplate>;
  heatPumpBrands: Array<Scalars['String']>;
  heatPumpIndoorUnit?: Maybe<HeatPumpIndoorUnit>;
  heatPumpIndoorUnits: Array<HeatPumpIndoorUnit>;
  heatPumpOutdoorUnit?: Maybe<HeatPumpOutdoorUnit>;
  heatPumpOutdoorUnits: Array<HeatPumpOutdoorUnit>;
  heatPumpPackages: Array<HeatPumpProductPackage>;
  inverter?: Maybe<Inverter>;
  inverterBrands: Array<Scalars['String']>;
  inverters: Array<Inverter>;
  me: User;
  newOfferExpenses: NewOfferExpenses;
  offer?: Maybe<Offer>;
  offerByCode?: Maybe<Offer>;
  offerByTag?: Maybe<Offer>;
  offerSavings: OfferSavings;
  offerTypeSavings: OfferSavingsWithProducts;
  offers?: Maybe<Array<Offer>>;
  productDescriptions: Array<ProductDescription>;
  recommendedSolarPackage: SolarProductPackage;
  residence?: Maybe<Residence>;
  residences?: Maybe<Array<Residence>>;
  residencesBySearch: Array<Residence>;
  searchCRMCustomers?: Maybe<Array<CrmCustomer>>;
  searchCustomers?: Maybe<Array<Customer>>;
  searchCustomersByEmail?: Maybe<Array<Customer>>;
  siteVisitAnswerList: Array<SiteVisitAnswer>;
  siteVisitFiles: Array<SiteVisitFile>;
  solarPackageSavings: Array<SolarPackageSavings>;
  solarPanel?: Maybe<SolarPanel>;
  solarPanelBrands: Array<Scalars['String']>;
  solarPanels: Array<SolarPanel>;
  solarProductPackages: Array<SolarProductPackage>;
  user?: Maybe<User>;
};


export type QueryAddressSavingsArgs = {
  dawaId: Scalars['String'];
  isAdvisor?: InputMaybe<Scalars['Boolean']>;
  residence?: InputMaybe<HouseInputWithUsage>;
};


export type QueryAllOfferTypeSavingsArgs = {
  address: AddressInput;
  chosenHeating?: InputMaybe<Scalars['Float']>;
  consumptionProfile?: InputMaybe<Array<Scalars['Float']>>;
  customerID?: InputMaybe<Scalars['Float']>;
  isAdvisor?: InputMaybe<Scalars['Boolean']>;
  residence?: InputMaybe<PartialResidenceInput>;
  types: Array<OfferType>;
};


export type QueryAssortedProductArgs = {
  id: Scalars['Int'];
};


export type QueryAssortedProductsArgs = {
  ids?: InputMaybe<Array<Scalars['Int']>>;
};


export type QueryBatteriesArgs = {
  ids?: InputMaybe<Array<Scalars['Int']>>;
  includeDisabled?: InputMaybe<Scalars['Boolean']>;
};


export type QueryBatteryArgs = {
  id: Scalars['Int'];
  includeDisabled?: InputMaybe<Scalars['Boolean']>;
};


export type QueryBatteryRangesArgs = {
  ids?: InputMaybe<Array<Scalars['Int']>>;
};


export type QueryBbrLookupByAddressArgs = {
  address: AddressInput;
};


export type QueryBbrLookupByDawaIdArgs = {
  dawaId: Scalars['String'];
};


export type QueryCalculateAddressSavingsArgs = {
  dawaId: Scalars['String'];
  residence?: InputMaybe<HouseInput>;
};


export type QueryCalculateAddressSavingsLokalBoligArgs = {
  dawaId: Scalars['String'];
  residence?: InputMaybe<HouseInput>;
};


export type QueryCalculateEnergyLabelsArgs = {
  address: AddressInput;
  residence?: InputMaybe<PartialResidenceInput>;
};


export type QueryCalculateOfferSavingsArgs = {
  address: AddressInput;
  chosenHeating?: InputMaybe<Scalars['Float']>;
  consumptionProfile?: InputMaybe<Array<Scalars['Float']>>;
  customerID?: InputMaybe<Scalars['Float']>;
  offer: OfferInput;
  residence?: InputMaybe<PartialResidenceInput>;
};


export type QueryCalculateOfferTypeSavingsArgs = {
  address: AddressInput;
  chosenHeating?: InputMaybe<Scalars['Float']>;
  consumptionProfile?: InputMaybe<Array<Scalars['Float']>>;
  customerID?: InputMaybe<Scalars['Float']>;
  residence?: InputMaybe<PartialResidenceInput>;
  types: Array<OfferType>;
};


export type QueryConstantsArgs = {
  code?: InputMaybe<Scalars['String']>;
};


export type QueryConstantsWithPartialCodeArgs = {
  partialCode: Scalars['String'];
};


export type QueryCrmCustomerFieldValuesArgs = {
  id: Scalars['String'];
};


export type QueryCustomerArgs = {
  email?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
};


export type QueryDashboardOffersArgs = {
  archived?: InputMaybe<Scalars['Boolean']>;
  limit?: InputMaybe<Scalars['Int']>;
  offerType?: InputMaybe<OfferType>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Scalars['String']>;
  orderDirection?: InputMaybe<SortOrder>;
  search?: InputMaybe<Scalars['String']>;
};


export type QueryEnergyLabelArgs = {
  addressId: Scalars['String'];
};


export type QueryEnergyOptionsArgs = {
  residenceId?: InputMaybe<Scalars['Int']>;
};


export type QueryExpenseTemplatesArgs = {
  type: OfferType;
};


export type QueryHeatPumpIndoorUnitArgs = {
  id: Scalars['Int'];
  includeDisabled?: InputMaybe<Scalars['Boolean']>;
};


export type QueryHeatPumpIndoorUnitsArgs = {
  ids?: InputMaybe<Array<Scalars['Int']>>;
  includeDisabled?: InputMaybe<Scalars['Boolean']>;
};


export type QueryHeatPumpOutdoorUnitArgs = {
  id: Scalars['Int'];
  includeDisabled?: InputMaybe<Scalars['Boolean']>;
};


export type QueryHeatPumpOutdoorUnitsArgs = {
  ids?: InputMaybe<Array<Scalars['Int']>>;
  includeDisabled?: InputMaybe<Scalars['Boolean']>;
};


export type QueryHeatPumpPackagesArgs = {
  ids?: InputMaybe<Array<Scalars['Int']>>;
};


export type QueryInverterArgs = {
  id: Scalars['Int'];
  includeDisabled?: InputMaybe<Scalars['Boolean']>;
};


export type QueryInvertersArgs = {
  ids?: InputMaybe<Array<Scalars['Int']>>;
  includeDisabled?: InputMaybe<Scalars['Boolean']>;
};


export type QueryOfferArgs = {
  id: Scalars['Int'];
};


export type QueryOfferByCodeArgs = {
  code: Scalars['String'];
  purpose: TokenPurpose;
};


export type QueryOfferByTagArgs = {
  offerTag: Scalars['String'];
};


export type QueryOfferSavingsArgs = {
  address?: InputMaybe<AddressInput>;
  chosenHeating?: InputMaybe<Scalars['Float']>;
  consumptionProfile?: InputMaybe<Array<Scalars['Float']>>;
  customerID?: InputMaybe<Scalars['Float']>;
  offer: OfferInput;
  residence: ResidenceInput;
};


export type QueryOfferTypeSavingsArgs = {
  address: AddressInput;
  chosenHeating?: InputMaybe<Scalars['Float']>;
  consumptionProfile?: InputMaybe<Array<Scalars['Float']>>;
  customerID?: InputMaybe<Scalars['Float']>;
  isAdvisor?: InputMaybe<Scalars['Boolean']>;
  residence?: InputMaybe<PartialResidenceInput>;
  types: Array<OfferType>;
};


export type QueryOffersArgs = {
  archived?: InputMaybe<Scalars['Boolean']>;
  customerID?: InputMaybe<Scalars['Int']>;
  residenceID?: InputMaybe<Scalars['Int']>;
};


export type QueryProductDescriptionsArgs = {
  type: OfferProductType;
};


export type QueryRecommendedSolarPackageArgs = {
  residence: ResidenceInput;
};


export type QueryResidenceArgs = {
  address?: InputMaybe<AddressInput>;
  customerID?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
};


export type QueryResidencesArgs = {
  address?: InputMaybe<AddressInput>;
  customerID?: InputMaybe<Scalars['Int']>;
};


export type QueryResidencesBySearchArgs = {
  actor?: InputMaybe<OfferActor>;
  search?: InputMaybe<Scalars['String']>;
};


export type QuerySearchCrmCustomersArgs = {
  email: Scalars['String'];
};


export type QuerySearchCustomersArgs = {
  search: Scalars['String'];
};


export type QuerySearchCustomersByEmailArgs = {
  email: Scalars['String'];
};


export type QuerySiteVisitAnswerListArgs = {
  residenceID: Scalars['Int'];
};


export type QuerySiteVisitFilesArgs = {
  code?: InputMaybe<Scalars['String']>;
  offerID: Scalars['Int'];
};


export type QuerySolarPackageSavingsArgs = {
  residence: ResidenceInput;
};


export type QuerySolarPanelArgs = {
  id: Scalars['Int'];
  includeDisabled?: InputMaybe<Scalars['Boolean']>;
};


export type QuerySolarPanelsArgs = {
  ids?: InputMaybe<Array<Scalars['Int']>>;
  includeDisabled?: InputMaybe<Scalars['Boolean']>;
};


export type QuerySolarProductPackagesArgs = {
  ids?: InputMaybe<Array<Scalars['Int']>>;
  isAdvisor?: InputMaybe<Scalars['Boolean']>;
  onlyDefaultBattery?: InputMaybe<Scalars['Boolean']>;
};


export type QueryUserArgs = {
  id: Scalars['Int'];
};

/** register user */
export type RegisterUserInput = {
  email: Scalars['String'];
  firstName: Scalars['String'];
  lastName: Scalars['String'];
  password: Scalars['String'];
};

export type RenovationDegreeEnum =
  | 'asBuilt'
  | 'maximum'
  | 'medium';

export type Residence = {
  address?: Maybe<Address>;
  addressID: Scalars['Int'];
  area: Scalars['Float'];
  areaHeated: Scalars['Float'];
  areaNotHeated?: Maybe<Scalars['Int']>;
  areaPartiallyHeated?: Maybe<Scalars['Float']>;
  builtYear?: Maybe<Scalars['Float']>;
  consumption?: Maybe<Consumption>;
  consumptionProfile?: Maybe<ConsumptionProfile>;
  createdAt: Scalars['Float'];
  customer?: Maybe<Customer>;
  customerID: Scalars['Int'];
  electricCar?: Maybe<ElectricCar>;
  electricityPrice?: Maybe<Scalars['Float']>;
  energyExpenditure: Scalars['Float'];
  energyLabel?: Maybe<EnergyLabelEnum>;
  floors: Scalars['Float'];
  heatDistribution: HeatDistributionTypeEnum;
  heatingCircuits?: Maybe<Scalars['Int']>;
  id: Scalars['Int'];
  images: Array<Image>;
  monthlyConsumption?: Maybe<MonthlyConsumption>;
  monthlyConsumptionProfile?: Maybe<MonthlyConsumptionProfile>;
  noiseWeight: WaterConsumptionDegreeEnum;
  offerProducts?: Maybe<Array<OfferType>>;
  primaryHeating?: Maybe<ResidenceHeating>;
  radiatorFloorPercentage?: Maybe<Scalars['Float']>;
  renovatedDegree?: Maybe<RenovationDegreeEnum>;
  renovatedYear?: Maybe<Scalars['Float']>;
  residents?: Maybe<Scalars['Float']>;
  roofType?: Maybe<RoofType>;
  roofs?: Maybe<Array<Roof>>;
  secondaryHeating?: Maybe<ResidenceHeating>;
  type: ResidenceType;
  updatedAt?: Maybe<Scalars['Float']>;
  waterConsumption: WaterConsumptionDegreeEnum;
};

export type ResidenceHeating = {
  annualUsage: Scalars['Float'];
  efficiency?: Maybe<Scalars['Float']>;
  fuelSubtype?: Maybe<Scalars['String']>;
  fuelType: Scalars['String'];
  heatSource?: Maybe<Scalars['String']>;
  id: Scalars['Int'];
  price?: Maybe<Scalars['Float']>;
  priority: HeatingPriority;
  volumeUnit?: Maybe<Scalars['String']>;
};

export type ResidenceHeatingInput = {
  annualUsage: Scalars['Float'];
  efficiency?: InputMaybe<Scalars['Float']>;
  fuelSubtype?: InputMaybe<Scalars['String']>;
  fuelType: Scalars['String'];
  heatSource?: InputMaybe<Scalars['String']>;
  price?: InputMaybe<Scalars['Float']>;
  priority?: InputMaybe<HeatingPriority>;
  volumeUnit?: InputMaybe<Scalars['String']>;
};

export type ResidenceInput = {
  address?: InputMaybe<AddressInput>;
  addressID?: InputMaybe<Scalars['Int']>;
  area: Scalars['Float'];
  areaHeated: Scalars['Float'];
  areaNotHeated?: InputMaybe<Scalars['Int']>;
  areaPartiallyHeated?: InputMaybe<Scalars['Float']>;
  builtYear?: InputMaybe<Scalars['Float']>;
  consumptionProfile?: InputMaybe<ConsumptionProfile>;
  customerID?: InputMaybe<Scalars['Int']>;
  electricCar?: InputMaybe<ElectricCarInput>;
  electricityPrice?: InputMaybe<Scalars['Float']>;
  energyExpenditure: Scalars['Float'];
  energyLabel?: InputMaybe<EnergyLabelEnum>;
  floors: Scalars['Float'];
  heatDistribution: HeatDistributionTypeEnum;
  heatingCircuits?: InputMaybe<Scalars['Int']>;
  monthlyConsumptionProfile?: InputMaybe<MonthlyConsumptionProfile>;
  noiseWeight?: InputMaybe<WaterConsumptionDegreeEnum>;
  primaryHeating: ResidenceHeatingInput;
  radiatorFloorPercentage?: InputMaybe<Scalars['Float']>;
  renovatedDegree?: InputMaybe<RenovationDegreeEnum>;
  renovatedYear?: InputMaybe<Scalars['Float']>;
  residents?: InputMaybe<Scalars['Float']>;
  roofType?: InputMaybe<RoofType>;
  roofs?: InputMaybe<Array<RoofInput>>;
  secondaryHeating?: InputMaybe<ResidenceHeatingInput>;
  type: ResidenceType;
  waterConsumption: WaterConsumptionDegreeEnum;
};

export type ResidenceOwnership =
  | 'lookingToBuy'
  | 'owner'
  | 'renting';

export type ResidenceType =
  | 'apartment'
  | 'summerhouse'
  | 'townhouse'
  | 'villa';

export type Roof = {
  height?: Maybe<Scalars['Float']>;
  isGuessed?: Maybe<Scalars['Boolean']>;
  maxPanelCoverage?: Maybe<Scalars['Float']>;
  orientation: Scalars['Float'];
  planeDepth: Scalars['Float'];
  planeWidth: Scalars['Float'];
  shadows?: Maybe<RoofShadows>;
};

export type RoofInput = {
  height?: InputMaybe<Scalars['Int']>;
  isGuessed?: InputMaybe<Scalars['Boolean']>;
  maxPanelCoverage?: InputMaybe<Scalars['Float']>;
  orientation: Scalars['Int'];
  planeDepth: Scalars['Int'];
  planeWidth: Scalars['Int'];
  shadows?: InputMaybe<RoofShadows>;
};

export type RoofShadows =
  | 'many'
  | 'none'
  | 'some';

export type RoofType =
  | 'clayTile'
  | 'concreteTile'
  | 'felt'
  | 'fiberCement'
  | 'flat'
  | 'metal'
  | 'other'
  | 'unknown';

export type ScoringFields = {
  heatingSource?: InputMaybe<HeatingSource>;
  interestedInAdvice?: InputMaybe<InterestedInAdvice>;
  investmentTime?: InputMaybe<InvestmentTime>;
  referencedBy?: InputMaybe<SourceOfReference>;
  residenceOwnership?: InputMaybe<ResidenceOwnership>;
  yearlyElectricityCost?: InputMaybe<YearlyElectricityCost>;
  yearlyHeatingCost?: InputMaybe<YearlyHeatingCost>;
};

export type SimpleResidenceResult = {
  annualElectricityPrice: Scalars['Float'];
  annualHeatingPrice: Scalars['Float'];
  existingSolarArrayEffect?: Maybe<Scalars['Float']>;
  fuelType: FuelType;
};

export type SiteVisitAnswer = {
  answer?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  question?: Maybe<SiteVisitQuestion>;
  residenceId: Scalars['Int'];
};

export type SiteVisitAnswerInput = {
  answer?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  question: SiteVisitQuestion;
  residenceId: Scalars['Int'];
};

export type SiteVisitFile = {
  id: Scalars['Float'];
  name: Scalars['String'];
  offerID: Scalars['Float'];
  url: Scalars['String'];
};

export type SiteVisitQuestion =
  | 'atticOrRaisedCelling'
  | 'bufferRequired'
  | 'bufferRequiredSolar'
  | 'bypassValves'
  | 'canFurnaceBeDismantled'
  | 'changeCirculationPump'
  | 'condensationPump'
  | 'correctColdRooms'
  | 'correctConsumption'
  | 'correctConsumptionSecondary'
  | 'correctHeatedArea'
  | 'digDownPipes'
  | 'distanceInOut'
  | 'distanceToInstallation'
  | 'distanceToSolar'
  | 'easyAvailableForScaffolding'
  | 'electricRelayAutoSafetyAndExtra'
  | 'electricRelayWork'
  | 'electricityNotes'
  | 'electricitySolarNotes'
  | 'floorHeatingExtraShunts'
  | 'floorPlanNotes'
  | 'hasUnderRoof'
  | 'heatPumpEntryPossible'
  | 'heatSourceNotes'
  | 'indoorAlternativeNotes'
  | 'indoorPlacementNotes'
  | 'indoorUnitOnFloorPlan'
  | 'installationOnFloorPlan'
  | 'inverterAndBatteryOnFloorPlan'
  | 'inverterAndBatteryPlacementNotes'
  | 'noiseLimitObserved'
  | 'otherNotes'
  | 'outdoorPlacementNotes'
  | 'outdoorUnitOnFloorPlan'
  | 'pipingMaterial'
  | 'pipingNotes'
  | 'pipingOnFloorPlan'
  | 'pipingPlacement'
  | 'providerForFoundation'
  | 'providerForFoundationSolar'
  | 'radiatorPipingSize'
  | 'radiatorsNotes'
  | 'replaceFurnaceWithRadiator'
  | 'replaceRadiators'
  | 'roofConstructionNotes'
  | 'roofType'
  | 'roomForMaterials'
  | 'roomForWaterTank'
  | 'solarCableOnFloorPlan'
  | 'solarEntryPossible'
  | 'solarOnFloorPlan'
  | 'solarPlacementNotes'
  | 'systemStringNumber'
  | 'twoPipingSystems'
  | 'wiringInCeiling'
  | 'wiringInCeilingForSolar';

export type SolarOfferInput = {
  batteryProduct?: InputMaybe<ProductInput>;
  discount?: InputMaybe<Scalars['Int']>;
  discountWithoutInstallation?: InputMaybe<Scalars['Int']>;
  expenses?: InputMaybe<Array<OfferExpenseInput>>;
  inverterProduct?: InputMaybe<ProductInput>;
  notes?: InputMaybe<Scalars['String']>;
  reservations?: InputMaybe<Scalars['String']>;
  solarPanelProduct?: InputMaybe<ProductInput>;
  withoutInstallation?: InputMaybe<Scalars['Boolean']>;
};

export type SolarPackageSavings = {
  packageID: Scalars['Int'];
  quantity: Scalars['Float'];
  savings: Scalars['Float'];
  title?: Maybe<Scalars['String']>;
  totalPrice: Scalars['Float'];
  totalSaved: Scalars['Float'];
  usedPercentage: Scalars['Float'];
};

export type SolarPanel = {
  annualProduction: Scalars['Float'];
  brand: Scalars['String'];
  buyPrice?: Maybe<Scalars['Float']>;
  capacity: Scalars['Float'];
  category: PanelCategory;
  compatibleInverters: Array<Scalars['Int']>;
  customerEnabled?: Maybe<Scalars['Boolean']>;
  datasheetUrl?: Maybe<Scalars['String']>;
  degradationPerYear: Scalars['Float'];
  deletedAt?: Maybe<Scalars['Float']>;
  descriptionId?: Maybe<Scalars['Int']>;
  enabled?: Maybe<Scalars['Boolean']>;
  id: Scalars['Float'];
  imageUrl?: Maybe<Scalars['String']>;
  model: Scalars['String'];
  notes?: Maybe<Scalars['String']>;
  offerID?: Maybe<Scalars['Float']>;
  performanceWarrantyYears: Scalars['Int'];
  preferred?: Maybe<Scalars['Boolean']>;
  price: Scalars['Float'];
  productWarrantyYears: Scalars['Int'];
  quantity?: Maybe<Scalars['Int']>;
  size: BoxSize;
  type: PanelType;
  webshopEnabled?: Maybe<Scalars['Boolean']>;
  weight: Scalars['Float'];
};

export type SolarPanelInput = {
  annualProduction: Scalars['Float'];
  boxSize?: InputMaybe<BoxSizeInput>;
  brand: Scalars['String'];
  buyPrice?: InputMaybe<Scalars['Float']>;
  capacity: Scalars['Float'];
  category: PanelCategory;
  compatibleInverters: Array<Scalars['Int']>;
  customerEnabled?: InputMaybe<Scalars['Boolean']>;
  cylinderSize?: InputMaybe<CylinderSizeInput>;
  datasheetUrl?: InputMaybe<Scalars['String']>;
  degradationPerYear: Scalars['Float'];
  deletedAt?: InputMaybe<Scalars['Float']>;
  descriptionId?: InputMaybe<Scalars['Int']>;
  enabled?: InputMaybe<Scalars['Boolean']>;
  imageUrl?: InputMaybe<Scalars['String']>;
  model: Scalars['String'];
  notes?: InputMaybe<Scalars['String']>;
  performanceWarrantyYears: Scalars['Int'];
  preferred?: InputMaybe<Scalars['Boolean']>;
  price: Scalars['Float'];
  productWarrantyYears: Scalars['Int'];
  type: PanelType;
  webshopEnabled?: InputMaybe<Scalars['Boolean']>;
  weight: Scalars['Float'];
};

export type SolarProductPackage = {
  batteries?: Maybe<Array<Battery>>;
  batteryRangeID?: Maybe<Scalars['Int']>;
  calculatorEnabled?: Maybe<Scalars['Boolean']>;
  defaultBatteryID?: Maybe<Scalars['Int']>;
  discount?: Maybe<Scalars['Float']>;
  discountWithoutInstallation?: Maybe<Scalars['Float']>;
  inverter: Inverter;
  maximumEnergyExpenditure?: Maybe<Scalars['Float']>;
  packageID: Scalars['Int'];
  solarPanel: SolarPanel;
  title?: Maybe<Scalars['String']>;
  webshopEnabled?: Maybe<Scalars['Boolean']>;
};

export type SolarProductPackageInput = {
  batteryRangeID?: InputMaybe<Scalars['Int']>;
  calculatorEnabled?: InputMaybe<Scalars['Boolean']>;
  defaultBatteryID?: InputMaybe<Scalars['Int']>;
  discount?: InputMaybe<Scalars['Float']>;
  discountWithoutInstallation?: InputMaybe<Scalars['Float']>;
  inverterID: Scalars['Int'];
  solarPanelID: Scalars['Int'];
  solarPanelQuantity: Scalars['Int'];
  title: Scalars['String'];
  webshopEnabled?: InputMaybe<Scalars['Boolean']>;
};

export type SortOrder =
  | 'ascending'
  | 'descending';

export type SourceOfReference =
  | 'google'
  | 'meta'
  | 'other'
  | 'partner'
  | 'trustPilot'
  | 'wordOfMouth';

export type TokenPurpose =
  | 'forgotPassword'
  | 'installationAccess'
  | 'refreshToken'
  | 'siteVisitAccess'
  | 'verifyEmail';

export type UpdateUserInput = {
  email?: InputMaybe<Scalars['String']>;
  firstName?: InputMaybe<Scalars['String']>;
  id: Scalars['Int'];
  lastName?: InputMaybe<Scalars['String']>;
  password?: InputMaybe<Scalars['String']>;
};

export type User = {
  authProviders?: Maybe<Array<AuthProvider>>;
  createdAt: Scalars['Float'];
  email: Scalars['String'];
  emailVerified?: Maybe<Scalars['Boolean']>;
  firstName: Scalars['String'];
  id: Scalars['Int'];
  isAdmin: Scalars['Boolean'];
  isMe: Scalars['Boolean'];
  lastName: Scalars['String'];
  name: Scalars['String'];
  phoneNumber?: Maybe<Scalars['String']>;
  profileImageID?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['Float']>;
};

export type UtmFields = {
  utmCampaign?: InputMaybe<Scalars['String']>;
  utmMedium?: InputMaybe<Scalars['String']>;
  utmSource?: InputMaybe<Scalars['String']>;
};

export type WaterConsumptionDegreeEnum =
  | 'large'
  | 'medium'
  | 'small';

export type YearlyElectricityCost =
  | 'between4000and14000'
  | 'lessThan4000'
  | 'moreThan14000'
  | 'unknown';

export type YearlyHeatingCost =
  | 'between4000and14000'
  | 'lessThan4000'
  | 'moreThan14000'
  | 'unknown';

export type BbrLookupByAddressQueryVariables = Exact<{
  address: AddressInput;
}>;


export type BbrLookupByAddressQuery = { bbrLookupByAddress?: { type: ResidenceType, floors: number, residents?: number | null, builtYear?: number | null, renovatedYear?: number | null, renovatedDegree?: RenovationDegreeEnum | null, area: number, areaHeated: number, areaNotHeated?: number | null, energyExpenditure: number, waterConsumption: WaterConsumptionDegreeEnum, heatDistribution?: HeatDistributionTypeEnum | null, primaryHeating?: { heatSource?: string | null, annualUsage: number, price?: number | null, efficiency?: number | null, fuelType: string, fuelSubtype?: string | null, volumeUnit?: string | null } | null, secondaryHeating?: { heatSource?: string | null } | null, roofs?: Array<{ orientation: number, planeWidth: number, planeDepth: number, height?: number | null, maxPanelCoverage?: number | null, shadows?: RoofShadows | null, isGuessed?: boolean | null }> | null } | null };

export type BbrLookupByDawaIdQueryVariables = Exact<{
  dawaId: Scalars['String'];
}>;


export type BbrLookupByDawaIdQuery = { bbrLookupByDawaId?: { type: ResidenceType, floors: number, residents?: number | null, builtYear?: number | null, renovatedYear?: number | null, renovatedDegree?: RenovationDegreeEnum | null, area: number, areaHeated: number, areaNotHeated?: number | null, energyExpenditure: number, waterConsumption: WaterConsumptionDegreeEnum, heatDistribution?: HeatDistributionTypeEnum | null, primaryHeating?: { heatSource?: string | null, annualUsage: number, price?: number | null, efficiency?: number | null, fuelType: string, fuelSubtype?: string | null, volumeUnit?: string | null } | null, secondaryHeating?: { heatSource?: string | null } | null, roofs?: Array<{ orientation: number, planeWidth: number, planeDepth: number, height?: number | null, maxPanelCoverage?: number | null, shadows?: RoofShadows | null, isGuessed?: boolean | null }> | null } | null };

export type CallMeMutationVariables = Exact<{
  name: Scalars['String'];
  phoneNumber: Scalars['String'];
  address?: InputMaybe<Scalars['String']>;
  leadOrigin?: InputMaybe<Scalars['String']>;
}>;


export type CallMeMutation = { callMe: boolean };

export type EnergyOptionsQueryVariables = Exact<{ [key: string]: never; }>;


export type EnergyOptionsQuery = { energyOptions: Array<{ code: string, valueNumber: number, numerator: string, denominator?: string | null }> };

export type EnergyLabelQueryVariables = Exact<{
  addressId: Scalars['String'];
}>;


export type EnergyLabelQuery = { energyLabel?: EnergyLabelEnum | null };

export type BoxSizeFragment = { height: number, width: number, depth: number };

export type CylinderSizeFragment = { height: number, diameter: number };

export type CompositeFigureFragment = { floor: number, radiator: number };

export type CompositeLabelFragment = { floor: string, radiator: string };

export type OfferExpenseTemplateFragment = { id: number, type: OfferExpenseTemplateType, minimumProducts?: number | null, price: number, includedByDefault?: boolean | null };

export type ConstantFragment = { code: string, valueNumber: number, numerator: string, denominator?: string | null };

export type HeatPumpIndoorUnitFragment = { id: number, brand: string, model: string, noiseLevel: number, waterVolume: number, buffer: number, deletedAt?: number | null, datasheetUrl?: string | null, price: number, preferred?: boolean | null, imageUrl?: string | null, size: { height: number, width: number, depth: number } | { height: number, diameter: number } };

export type HeatPumpOutdoorUnitFragment = { id: number, brand: string, model: string, noiseLevel: number, deletedAt?: number | null, temperatureOut: number, datasheetUrl?: string | null, compatibleIndoorUnits: Array<number>, price: number, preferred?: boolean | null, imageUrl?: string | null, size: { height: number, width: number, depth: number } | { height: number, diameter: number }, scop: { floor: number, radiator: number }, effect7: { floor: number, radiator: number }, effect12: { floor: number, radiator: number }, energyLabel: { floor: string, radiator: string } };

export type SolarPanelFragment = { id: number, brand: string, model: string, weight: number, annualProduction: number, capacity: number, productWarrantyYears: number, performanceWarrantyYears: number, degradationPerYear: number, deletedAt?: number | null, datasheetUrl?: string | null, quantity?: number | null, category: PanelCategory, type: PanelType, price: number, preferred?: boolean | null, compatibleInverters: Array<number>, imageUrl?: string | null, size: { height: number, width: number, depth: number } };

export type InverterFragment = { id: number, brand: string, model: string, weight: number, efficiency: number, capacity: number, warrantyYears: number, compatibleBatteries?: Array<number> | null, deletedAt?: number | null, datasheetUrl?: string | null, quantity?: number | null, price: number, preferred?: boolean | null, imageUrl?: string | null, size: { height: number, width: number, depth: number } | { height: number, diameter: number } };

export type BatteryFragment = { id: number, brand: string, model: string, weight: number, efficiency: number, capacity: number, warrantyYears?: number | null, warrantyCycles?: number | null, deletedAt?: number | null, datasheetUrl?: string | null, quantity?: number | null, price: number, preferred?: boolean | null, imageUrl?: string | null, size: { height: number, width: number, depth: number } | { height: number, diameter: number } };

export type HeatPumpIndoorUnitsQueryVariables = Exact<{
  ids?: InputMaybe<Array<Scalars['Int']> | Scalars['Int']>;
}>;


export type HeatPumpIndoorUnitsQuery = { heatPumpIndoorUnits: Array<{ id: number, brand: string, model: string, noiseLevel: number, waterVolume: number, buffer: number, deletedAt?: number | null, datasheetUrl?: string | null, price: number, preferred?: boolean | null, imageUrl?: string | null, size: { height: number, width: number, depth: number } | { height: number, diameter: number } }> };

export type HeatPumpOutdoorUnitsQueryVariables = Exact<{
  ids?: InputMaybe<Array<Scalars['Int']> | Scalars['Int']>;
}>;


export type HeatPumpOutdoorUnitsQuery = { heatPumpOutdoorUnits: Array<{ id: number, brand: string, model: string, noiseLevel: number, deletedAt?: number | null, temperatureOut: number, datasheetUrl?: string | null, compatibleIndoorUnits: Array<number>, price: number, preferred?: boolean | null, imageUrl?: string | null, size: { height: number, width: number, depth: number } | { height: number, diameter: number }, scop: { floor: number, radiator: number }, effect7: { floor: number, radiator: number }, effect12: { floor: number, radiator: number }, energyLabel: { floor: string, radiator: string } }> };

export type RegisterLeadMutationVariables = Exact<{
  customer: CustomerInput;
  address: AddressInput;
}>;


export type RegisterLeadMutation = { registerLead: boolean };

export type InsertAndSendOffersMutationVariables = Exact<{
  heatPumpOffers?: InputMaybe<Array<HeatPumpOfferInput> | HeatPumpOfferInput>;
  solarOffers?: InputMaybe<Array<SolarOfferInput> | SolarOfferInput>;
  customer: CustomerInput;
  residence: ResidenceInput;
  address: AddressInput;
  dataConsent?: InputMaybe<DataConsentInput>;
}>;


export type InsertAndSendOffersMutation = { insertAndSendOffers: boolean };

export type OfferSavingsQueryVariables = Exact<{
  address: AddressInput;
  residence: ResidenceInput;
  offer: OfferInput;
  chosenHeating?: InputMaybe<Scalars['Float']>;
  consumptionProfile?: InputMaybe<Array<Scalars['Float']> | Scalars['Float']>;
  customerID?: InputMaybe<Scalars['Float']>;
}>;


export type OfferSavingsQuery = { offerSavings: { before: { produced: number, bought: number, sold: number, used: number, usedPercentage?: number | null, consumptionPerMonth?: Array<number> | null, productionPerMonth?: Array<number> | null, totalPrice: number, domesticPrice: number, fuelPrice?: number | null, boughtPrice?: number | null, netEarning?: number | null, soldPrice?: number | null, domesticDiscount: number, electricityDiscount?: number | null, totalEmission?: number | null }, after: { produced: number, bought: number, sold: number, used: number, usedPercentage?: number | null, consumptionPerMonth?: Array<number> | null, productionPerMonth?: Array<number> | null, totalPrice: number, domesticPrice: number, fuelPrice?: number | null, boughtPrice?: number | null, netEarning?: number | null, soldPrice?: number | null, domesticDiscount: number, electricityDiscount?: number | null, totalEmission?: number | null }, saved: { price: number, emission: number, priceByYear: Array<number> } } };

export type OfferTypeSavingsQueryVariables = Exact<{
  address: AddressInput;
  types: Array<OfferType> | OfferType;
}>;


export type OfferTypeSavingsQuery = { offerTypeSavings: { savings: { after: { produced: number, bought: number, sold: number, used: number, usedPercentage?: number | null, consumptionPerMonth?: Array<number> | null, productionPerMonth?: Array<number> | null, totalPrice: number, domesticPrice: number, fuelPrice?: number | null, boughtPrice?: number | null, netEarning?: number | null, soldPrice?: number | null, domesticDiscount: number, electricityDiscount?: number | null, totalEmission?: number | null }, before: { produced: number, bought: number, sold: number, used: number, usedPercentage?: number | null, consumptionPerMonth?: Array<number> | null, productionPerMonth?: Array<number> | null, totalPrice: number, domesticPrice: number, fuelPrice?: number | null, boughtPrice?: number | null, netEarning?: number | null, soldPrice?: number | null, domesticDiscount: number, electricityDiscount?: number | null, totalEmission?: number | null }, saved: { price: number, priceByYear: Array<number>, emission: number } }, products: { price?: number | null, solarPackageId?: number | null, solarPackageDiscount?: number | null, heatPumpOutdoorUnit?: { id: number, price: number, buyPrice?: number | null, brand: string, model: string, imageUrl?: string | null } | null, solarPanel?: { id: number, price: number, buyPrice?: number | null, brand: string, model: string, imageUrl?: string | null, quantity?: number | null, annualProduction: number } | null, inverter?: { id: number, price: number, buyPrice?: number | null, brand: string } | null, battery?: { id: number, price: number, buyPrice?: number | null, brand: string, capacity: number } | null, heatPumpIndoorUnit?: { id: number, price: number, buyPrice?: number | null, brand: string } | null } } };

export type ProductUsageFragment = { produced: number, bought: number, sold: number, used: number, usedPercentage?: number | null, consumptionPerMonth?: Array<number> | null, productionPerMonth?: Array<number> | null, totalPrice: number, domesticPrice: number, fuelPrice?: number | null, boughtPrice?: number | null, netEarning?: number | null, soldPrice?: number | null, domesticDiscount: number, electricityDiscount?: number | null, totalEmission?: number | null };

export type NewOfferExpensesQueryVariables = Exact<{ [key: string]: never; }>;


export type NewOfferExpensesQuery = { newOfferExpenses: { heatPump: Array<{ id: number, type: OfferExpenseTemplateType, minimumProducts?: number | null, price: number, includedByDefault?: boolean | null }>, solar: Array<{ id: number, type: OfferExpenseTemplateType, minimumProducts?: number | null, price: number, includedByDefault?: boolean | null }> } };

export type SolarProductPackagesQueryVariables = Exact<{ [key: string]: never; }>;


export type SolarProductPackagesQuery = { solarProductPackages: Array<{ packageID: number, maximumEnergyExpenditure?: number | null, discount?: number | null, solarPanel: { id: number, brand: string, model: string, weight: number, annualProduction: number, capacity: number, productWarrantyYears: number, performanceWarrantyYears: number, degradationPerYear: number, deletedAt?: number | null, datasheetUrl?: string | null, quantity?: number | null, category: PanelCategory, type: PanelType, price: number, preferred?: boolean | null, compatibleInverters: Array<number>, imageUrl?: string | null, size: { height: number, width: number, depth: number } }, inverter: { id: number, brand: string, model: string, weight: number, efficiency: number, capacity: number, warrantyYears: number, compatibleBatteries?: Array<number> | null, deletedAt?: number | null, datasheetUrl?: string | null, quantity?: number | null, price: number, preferred?: boolean | null, imageUrl?: string | null, size: { height: number, width: number, depth: number } | { height: number, diameter: number } }, batteries?: Array<{ id: number, brand: string, model: string, weight: number, efficiency: number, capacity: number, warrantyYears?: number | null, warrantyCycles?: number | null, deletedAt?: number | null, datasheetUrl?: string | null, quantity?: number | null, price: number, preferred?: boolean | null, imageUrl?: string | null, size: { height: number, width: number, depth: number } | { height: number, diameter: number } }> | null }> };

export type AddressSavingsQueryVariables = Exact<{
  dawaId: Scalars['String'];
}>;


export type AddressSavingsQuery = { addressSavings: { results: Array<{ types: Array<OfferType>, paybackMonths: number, savings: { saved: { price: number, emission: number, priceByYear: Array<number> } }, products: { price?: number | null, heatPumpIndoorUnit?: { id: number, model: string, brand: string, imageUrl?: string | null, price: number } | null, heatPumpOutdoorUnit?: { id: number, model: string, brand: string, imageUrl?: string | null, price: number } | null, solarPanel?: { id: number, model: string, brand: string, imageUrl?: string | null, price: number, annualProduction: number, quantity?: number | null } | null, inverter?: { id: number, model: string, brand: string, imageUrl?: string | null, price: number } | null, battery?: { id: number, model: string, brand: string, imageUrl?: string | null, price: number, capacity: number } | null } }> } };

export const OfferExpenseTemplateFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"OfferExpenseTemplate"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"OfferExpenseTemplate"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"minimumProducts"}},{"kind":"Field","name":{"kind":"Name","value":"price"}},{"kind":"Field","name":{"kind":"Name","value":"includedByDefault"}}]}}]} as unknown as DocumentNode<OfferExpenseTemplateFragment, unknown>;
export const ConstantFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Constant"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Constant"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"valueNumber"}},{"kind":"Field","name":{"kind":"Name","value":"numerator"}},{"kind":"Field","name":{"kind":"Name","value":"denominator"}}]}}]} as unknown as DocumentNode<ConstantFragment, unknown>;
export const BoxSizeFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"BoxSize"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"BoxSize"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"height"}},{"kind":"Field","name":{"kind":"Name","value":"width"}},{"kind":"Field","name":{"kind":"Name","value":"depth"}}]}}]} as unknown as DocumentNode<BoxSizeFragment, unknown>;
export const CylinderSizeFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"CylinderSize"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"CylinderSize"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"height"}},{"kind":"Field","name":{"kind":"Name","value":"diameter"}}]}}]} as unknown as DocumentNode<CylinderSizeFragment, unknown>;
export const HeatPumpIndoorUnitFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"HeatPumpIndoorUnit"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"HeatPumpIndoorUnit"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"brand"}},{"kind":"Field","name":{"kind":"Name","value":"model"}},{"kind":"Field","name":{"kind":"Name","value":"noiseLevel"}},{"kind":"Field","name":{"kind":"Name","value":"waterVolume"}},{"kind":"Field","name":{"kind":"Name","value":"buffer"}},{"kind":"Field","name":{"kind":"Name","value":"deletedAt"}},{"kind":"Field","name":{"kind":"Name","value":"datasheetUrl"}},{"kind":"Field","name":{"kind":"Name","value":"price"}},{"kind":"Field","name":{"kind":"Name","value":"preferred"}},{"kind":"Field","name":{"kind":"Name","value":"size"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"BoxSize"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"BoxSize"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"CylinderSize"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"CylinderSize"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"imageUrl"}}]}}]} as unknown as DocumentNode<HeatPumpIndoorUnitFragment, unknown>;
export const CompositeFigureFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"CompositeFigure"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"CompositeFigure"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"floor"}},{"kind":"Field","name":{"kind":"Name","value":"radiator"}}]}}]} as unknown as DocumentNode<CompositeFigureFragment, unknown>;
export const CompositeLabelFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"CompositeLabel"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"CompositeLabel"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"floor"}},{"kind":"Field","name":{"kind":"Name","value":"radiator"}}]}}]} as unknown as DocumentNode<CompositeLabelFragment, unknown>;
export const HeatPumpOutdoorUnitFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"HeatPumpOutdoorUnit"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"HeatPumpOutdoorUnit"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"brand"}},{"kind":"Field","name":{"kind":"Name","value":"model"}},{"kind":"Field","name":{"kind":"Name","value":"noiseLevel"}},{"kind":"Field","name":{"kind":"Name","value":"deletedAt"}},{"kind":"Field","name":{"kind":"Name","value":"temperatureOut"}},{"kind":"Field","name":{"kind":"Name","value":"datasheetUrl"}},{"kind":"Field","name":{"kind":"Name","value":"compatibleIndoorUnits"}},{"kind":"Field","name":{"kind":"Name","value":"price"}},{"kind":"Field","name":{"kind":"Name","value":"preferred"}},{"kind":"Field","name":{"kind":"Name","value":"size"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"BoxSize"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"BoxSize"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"CylinderSize"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"CylinderSize"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"imageUrl"}},{"kind":"Field","name":{"kind":"Name","value":"scop"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"CompositeFigure"}}]}},{"kind":"Field","name":{"kind":"Name","value":"effect7"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"CompositeFigure"}}]}},{"kind":"Field","name":{"kind":"Name","value":"effect12"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"CompositeFigure"}}]}},{"kind":"Field","name":{"kind":"Name","value":"energyLabel"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"CompositeLabel"}}]}}]}}]} as unknown as DocumentNode<HeatPumpOutdoorUnitFragment, unknown>;
export const SolarPanelFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"SolarPanel"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"SolarPanel"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"brand"}},{"kind":"Field","name":{"kind":"Name","value":"model"}},{"kind":"Field","name":{"kind":"Name","value":"weight"}},{"kind":"Field","name":{"kind":"Name","value":"annualProduction"}},{"kind":"Field","name":{"kind":"Name","value":"capacity"}},{"kind":"Field","name":{"kind":"Name","value":"productWarrantyYears"}},{"kind":"Field","name":{"kind":"Name","value":"performanceWarrantyYears"}},{"kind":"Field","name":{"kind":"Name","value":"degradationPerYear"}},{"kind":"Field","name":{"kind":"Name","value":"deletedAt"}},{"kind":"Field","name":{"kind":"Name","value":"datasheetUrl"}},{"kind":"Field","name":{"kind":"Name","value":"quantity"}},{"kind":"Field","name":{"kind":"Name","value":"category"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"price"}},{"kind":"Field","name":{"kind":"Name","value":"preferred"}},{"kind":"Field","name":{"kind":"Name","value":"compatibleInverters"}},{"kind":"Field","name":{"kind":"Name","value":"size"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"BoxSize"}}]}},{"kind":"Field","name":{"kind":"Name","value":"imageUrl"}}]}}]} as unknown as DocumentNode<SolarPanelFragment, unknown>;
export const InverterFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Inverter"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Inverter"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"brand"}},{"kind":"Field","name":{"kind":"Name","value":"model"}},{"kind":"Field","name":{"kind":"Name","value":"weight"}},{"kind":"Field","name":{"kind":"Name","value":"efficiency"}},{"kind":"Field","name":{"kind":"Name","value":"capacity"}},{"kind":"Field","name":{"kind":"Name","value":"warrantyYears"}},{"kind":"Field","name":{"kind":"Name","value":"compatibleBatteries"}},{"kind":"Field","name":{"kind":"Name","value":"deletedAt"}},{"kind":"Field","name":{"kind":"Name","value":"datasheetUrl"}},{"kind":"Field","name":{"kind":"Name","value":"quantity"}},{"kind":"Field","name":{"kind":"Name","value":"price"}},{"kind":"Field","name":{"kind":"Name","value":"preferred"}},{"kind":"Field","name":{"kind":"Name","value":"size"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"BoxSize"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"BoxSize"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"CylinderSize"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"CylinderSize"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"imageUrl"}}]}}]} as unknown as DocumentNode<InverterFragment, unknown>;
export const BatteryFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Battery"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Battery"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"brand"}},{"kind":"Field","name":{"kind":"Name","value":"model"}},{"kind":"Field","name":{"kind":"Name","value":"weight"}},{"kind":"Field","name":{"kind":"Name","value":"efficiency"}},{"kind":"Field","name":{"kind":"Name","value":"capacity"}},{"kind":"Field","name":{"kind":"Name","value":"warrantyYears"}},{"kind":"Field","name":{"kind":"Name","value":"warrantyCycles"}},{"kind":"Field","name":{"kind":"Name","value":"deletedAt"}},{"kind":"Field","name":{"kind":"Name","value":"datasheetUrl"}},{"kind":"Field","name":{"kind":"Name","value":"quantity"}},{"kind":"Field","name":{"kind":"Name","value":"price"}},{"kind":"Field","name":{"kind":"Name","value":"preferred"}},{"kind":"Field","name":{"kind":"Name","value":"size"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"BoxSize"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"BoxSize"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"CylinderSize"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"CylinderSize"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"imageUrl"}}]}}]} as unknown as DocumentNode<BatteryFragment, unknown>;
export const ProductUsageFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ProductUsage"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ProductUsage"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"produced"}},{"kind":"Field","name":{"kind":"Name","value":"bought"}},{"kind":"Field","name":{"kind":"Name","value":"sold"}},{"kind":"Field","name":{"kind":"Name","value":"used"}},{"kind":"Field","name":{"kind":"Name","value":"usedPercentage"}},{"kind":"Field","name":{"kind":"Name","value":"consumptionPerMonth"}},{"kind":"Field","name":{"kind":"Name","value":"productionPerMonth"}},{"kind":"Field","name":{"kind":"Name","value":"totalPrice"}},{"kind":"Field","name":{"kind":"Name","value":"domesticPrice"}},{"kind":"Field","name":{"kind":"Name","value":"fuelPrice"}},{"kind":"Field","name":{"kind":"Name","value":"boughtPrice"}},{"kind":"Field","name":{"kind":"Name","value":"netEarning"}},{"kind":"Field","name":{"kind":"Name","value":"soldPrice"}},{"kind":"Field","name":{"kind":"Name","value":"domesticDiscount"}},{"kind":"Field","name":{"kind":"Name","value":"electricityDiscount"}},{"kind":"Field","name":{"kind":"Name","value":"totalEmission"}}]}}]} as unknown as DocumentNode<ProductUsageFragment, unknown>;
export const BbrLookupByAddressDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"bbrLookupByAddress"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"address"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"AddressInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"bbrLookupByAddress"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"address"},"value":{"kind":"Variable","name":{"kind":"Name","value":"address"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"floors"}},{"kind":"Field","name":{"kind":"Name","value":"residents"}},{"kind":"Field","name":{"kind":"Name","value":"builtYear"}},{"kind":"Field","name":{"kind":"Name","value":"renovatedYear"}},{"kind":"Field","name":{"kind":"Name","value":"renovatedDegree"}},{"kind":"Field","name":{"kind":"Name","value":"area"}},{"kind":"Field","name":{"kind":"Name","value":"areaHeated"}},{"kind":"Field","name":{"kind":"Name","value":"areaNotHeated"}},{"kind":"Field","name":{"kind":"Name","value":"energyExpenditure"}},{"kind":"Field","name":{"kind":"Name","value":"waterConsumption"}},{"kind":"Field","name":{"kind":"Name","value":"heatDistribution"}},{"kind":"Field","name":{"kind":"Name","value":"primaryHeating"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"heatSource"}},{"kind":"Field","name":{"kind":"Name","value":"annualUsage"}},{"kind":"Field","name":{"kind":"Name","value":"price"}},{"kind":"Field","name":{"kind":"Name","value":"efficiency"}},{"kind":"Field","name":{"kind":"Name","value":"fuelType"}},{"kind":"Field","name":{"kind":"Name","value":"fuelSubtype"}},{"kind":"Field","name":{"kind":"Name","value":"volumeUnit"}}]}},{"kind":"Field","name":{"kind":"Name","value":"secondaryHeating"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"heatSource"}}]}},{"kind":"Field","name":{"kind":"Name","value":"roofs"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"orientation"}},{"kind":"Field","name":{"kind":"Name","value":"planeWidth"}},{"kind":"Field","name":{"kind":"Name","value":"planeDepth"}},{"kind":"Field","name":{"kind":"Name","value":"height"}},{"kind":"Field","name":{"kind":"Name","value":"maxPanelCoverage"}},{"kind":"Field","name":{"kind":"Name","value":"shadows"}},{"kind":"Field","name":{"kind":"Name","value":"isGuessed"}}]}}]}}]}}]} as unknown as DocumentNode<BbrLookupByAddressQuery, BbrLookupByAddressQueryVariables>;
export const BbrLookupByDawaIdDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"bbrLookupByDawaId"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"dawaId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"bbrLookupByDawaId"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"dawaId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"dawaId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"floors"}},{"kind":"Field","name":{"kind":"Name","value":"residents"}},{"kind":"Field","name":{"kind":"Name","value":"builtYear"}},{"kind":"Field","name":{"kind":"Name","value":"renovatedYear"}},{"kind":"Field","name":{"kind":"Name","value":"renovatedDegree"}},{"kind":"Field","name":{"kind":"Name","value":"area"}},{"kind":"Field","name":{"kind":"Name","value":"areaHeated"}},{"kind":"Field","name":{"kind":"Name","value":"areaNotHeated"}},{"kind":"Field","name":{"kind":"Name","value":"energyExpenditure"}},{"kind":"Field","name":{"kind":"Name","value":"waterConsumption"}},{"kind":"Field","name":{"kind":"Name","value":"heatDistribution"}},{"kind":"Field","name":{"kind":"Name","value":"primaryHeating"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"heatSource"}},{"kind":"Field","name":{"kind":"Name","value":"annualUsage"}},{"kind":"Field","name":{"kind":"Name","value":"price"}},{"kind":"Field","name":{"kind":"Name","value":"efficiency"}},{"kind":"Field","name":{"kind":"Name","value":"fuelType"}},{"kind":"Field","name":{"kind":"Name","value":"fuelSubtype"}},{"kind":"Field","name":{"kind":"Name","value":"volumeUnit"}}]}},{"kind":"Field","name":{"kind":"Name","value":"secondaryHeating"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"heatSource"}}]}},{"kind":"Field","name":{"kind":"Name","value":"roofs"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"orientation"}},{"kind":"Field","name":{"kind":"Name","value":"planeWidth"}},{"kind":"Field","name":{"kind":"Name","value":"planeDepth"}},{"kind":"Field","name":{"kind":"Name","value":"height"}},{"kind":"Field","name":{"kind":"Name","value":"maxPanelCoverage"}},{"kind":"Field","name":{"kind":"Name","value":"shadows"}},{"kind":"Field","name":{"kind":"Name","value":"isGuessed"}}]}}]}}]}}]} as unknown as DocumentNode<BbrLookupByDawaIdQuery, BbrLookupByDawaIdQueryVariables>;
export const CallMeDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"callMe"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"name"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"phoneNumber"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"address"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"leadOrigin"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"callMe"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"name"},"value":{"kind":"Variable","name":{"kind":"Name","value":"name"}}},{"kind":"Argument","name":{"kind":"Name","value":"phoneNumber"},"value":{"kind":"Variable","name":{"kind":"Name","value":"phoneNumber"}}},{"kind":"Argument","name":{"kind":"Name","value":"address"},"value":{"kind":"Variable","name":{"kind":"Name","value":"address"}}},{"kind":"Argument","name":{"kind":"Name","value":"leadOrigin"},"value":{"kind":"Variable","name":{"kind":"Name","value":"leadOrigin"}}}]}]}}]} as unknown as DocumentNode<CallMeMutation, CallMeMutationVariables>;
export const EnergyOptionsDocument = {"kind":"Document", "definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"energyOptions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"energyOptions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Constant"}}]}}]}},...ConstantFragmentDoc.definitions]} as unknown as DocumentNode<EnergyOptionsQuery, EnergyOptionsQueryVariables>;
export const EnergyLabelDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"energyLabel"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"addressId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"energyLabel"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"addressId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"addressId"}}}]}]}}]} as unknown as DocumentNode<EnergyLabelQuery, EnergyLabelQueryVariables>;
export const HeatPumpIndoorUnitsDocument = {"kind":"Document", "definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"heatPumpIndoorUnits"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"ids"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"heatPumpIndoorUnits"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"ids"},"value":{"kind":"Variable","name":{"kind":"Name","value":"ids"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"HeatPumpIndoorUnit"}}]}}]}},...HeatPumpIndoorUnitFragmentDoc.definitions,...BoxSizeFragmentDoc.definitions,...CylinderSizeFragmentDoc.definitions]} as unknown as DocumentNode<HeatPumpIndoorUnitsQuery, HeatPumpIndoorUnitsQueryVariables>;
export const HeatPumpOutdoorUnitsDocument = {"kind":"Document", "definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"heatPumpOutdoorUnits"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"ids"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"heatPumpOutdoorUnits"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"ids"},"value":{"kind":"Variable","name":{"kind":"Name","value":"ids"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"HeatPumpOutdoorUnit"}}]}}]}},...HeatPumpOutdoorUnitFragmentDoc.definitions,...BoxSizeFragmentDoc.definitions,...CylinderSizeFragmentDoc.definitions,...CompositeFigureFragmentDoc.definitions,...CompositeLabelFragmentDoc.definitions]} as unknown as DocumentNode<HeatPumpOutdoorUnitsQuery, HeatPumpOutdoorUnitsQueryVariables>;
export const RegisterLeadDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"registerLead"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"customer"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CustomerInput"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"address"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"AddressInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"registerLead"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"customer"},"value":{"kind":"Variable","name":{"kind":"Name","value":"customer"}}},{"kind":"Argument","name":{"kind":"Name","value":"address"},"value":{"kind":"Variable","name":{"kind":"Name","value":"address"}}}]}]}}]} as unknown as DocumentNode<RegisterLeadMutation, RegisterLeadMutationVariables>;
export const InsertAndSendOffersDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"insertAndSendOffers"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"heatPumpOffers"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"HeatPumpOfferInput"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"solarOffers"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"SolarOfferInput"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"customer"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CustomerInput"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"residence"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ResidenceInput"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"address"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"AddressInput"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"dataConsent"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"DataConsentInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"insertAndSendOffers"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"heatPumpOffers"},"value":{"kind":"Variable","name":{"kind":"Name","value":"heatPumpOffers"}}},{"kind":"Argument","name":{"kind":"Name","value":"solarOffers"},"value":{"kind":"Variable","name":{"kind":"Name","value":"solarOffers"}}},{"kind":"Argument","name":{"kind":"Name","value":"customer"},"value":{"kind":"Variable","name":{"kind":"Name","value":"customer"}}},{"kind":"Argument","name":{"kind":"Name","value":"residence"},"value":{"kind":"Variable","name":{"kind":"Name","value":"residence"}}},{"kind":"Argument","name":{"kind":"Name","value":"address"},"value":{"kind":"Variable","name":{"kind":"Name","value":"address"}}},{"kind":"Argument","name":{"kind":"Name","value":"dataConsent"},"value":{"kind":"Variable","name":{"kind":"Name","value":"dataConsent"}}}]}]}}]} as unknown as DocumentNode<InsertAndSendOffersMutation, InsertAndSendOffersMutationVariables>;
export const OfferSavingsDocument = {"kind":"Document", "definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"offerSavings"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"address"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"AddressInput"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"residence"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ResidenceInput"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"offer"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"OfferInput"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"chosenHeating"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Float"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"consumptionProfile"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Float"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"customerID"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Float"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"offerSavings"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"address"},"value":{"kind":"Variable","name":{"kind":"Name","value":"address"}}},{"kind":"Argument","name":{"kind":"Name","value":"residence"},"value":{"kind":"Variable","name":{"kind":"Name","value":"residence"}}},{"kind":"Argument","name":{"kind":"Name","value":"offer"},"value":{"kind":"Variable","name":{"kind":"Name","value":"offer"}}},{"kind":"Argument","name":{"kind":"Name","value":"chosenHeating"},"value":{"kind":"Variable","name":{"kind":"Name","value":"chosenHeating"}}},{"kind":"Argument","name":{"kind":"Name","value":"consumptionProfile"},"value":{"kind":"Variable","name":{"kind":"Name","value":"consumptionProfile"}}},{"kind":"Argument","name":{"kind":"Name","value":"customerID"},"value":{"kind":"Variable","name":{"kind":"Name","value":"customerID"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"before"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProductUsage"}}]}},{"kind":"Field","name":{"kind":"Name","value":"after"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProductUsage"}}]}},{"kind":"Field","name":{"kind":"Name","value":"saved"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"price"}},{"kind":"Field","name":{"kind":"Name","value":"emission"}},{"kind":"Field","name":{"kind":"Name","value":"priceByYear"}}]}}]}}]}},...ProductUsageFragmentDoc.definitions]} as unknown as DocumentNode<OfferSavingsQuery, OfferSavingsQueryVariables>;
export const OfferTypeSavingsDocument = {"kind":"Document", "definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"offerTypeSavings"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"address"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"AddressInput"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"types"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"OfferType"}}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"offerTypeSavings"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"address"},"value":{"kind":"Variable","name":{"kind":"Name","value":"address"}}},{"kind":"Argument","name":{"kind":"Name","value":"types"},"value":{"kind":"Variable","name":{"kind":"Name","value":"types"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"savings"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"after"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProductUsage"}}]}},{"kind":"Field","name":{"kind":"Name","value":"before"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProductUsage"}}]}},{"kind":"Field","name":{"kind":"Name","value":"saved"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"price"}},{"kind":"Field","name":{"kind":"Name","value":"priceByYear"}},{"kind":"Field","name":{"kind":"Name","value":"emission"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"products"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"price"}},{"kind":"Field","name":{"kind":"Name","value":"solarPackageId"}},{"kind":"Field","name":{"kind":"Name","value":"solarPackageDiscount"}},{"kind":"Field","name":{"kind":"Name","value":"heatPumpOutdoorUnit"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"price"}},{"kind":"Field","name":{"kind":"Name","value":"buyPrice"}},{"kind":"Field","name":{"kind":"Name","value":"brand"}},{"kind":"Field","name":{"kind":"Name","value":"model"}},{"kind":"Field","name":{"kind":"Name","value":"imageUrl"}}]}},{"kind":"Field","name":{"kind":"Name","value":"solarPanel"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"price"}},{"kind":"Field","name":{"kind":"Name","value":"buyPrice"}},{"kind":"Field","name":{"kind":"Name","value":"brand"}},{"kind":"Field","name":{"kind":"Name","value":"model"}},{"kind":"Field","name":{"kind":"Name","value":"imageUrl"}},{"kind":"Field","name":{"kind":"Name","value":"quantity"}},{"kind":"Field","name":{"kind":"Name","value":"annualProduction"}}]}},{"kind":"Field","name":{"kind":"Name","value":"inverter"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"price"}},{"kind":"Field","name":{"kind":"Name","value":"buyPrice"}},{"kind":"Field","name":{"kind":"Name","value":"brand"}}]}},{"kind":"Field","name":{"kind":"Name","value":"battery"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"price"}},{"kind":"Field","name":{"kind":"Name","value":"buyPrice"}},{"kind":"Field","name":{"kind":"Name","value":"brand"}},{"kind":"Field","name":{"kind":"Name","value":"capacity"}}]}},{"kind":"Field","name":{"kind":"Name","value":"heatPumpIndoorUnit"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"price"}},{"kind":"Field","name":{"kind":"Name","value":"buyPrice"}},{"kind":"Field","name":{"kind":"Name","value":"brand"}}]}}]}}]}}]}},...ProductUsageFragmentDoc.definitions]} as unknown as DocumentNode<OfferTypeSavingsQuery, OfferTypeSavingsQueryVariables>;
export const NewOfferExpensesDocument = {"kind":"Document", "definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"newOfferExpenses"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"newOfferExpenses"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"heatPump"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"OfferExpenseTemplate"}}]}},{"kind":"Field","name":{"kind":"Name","value":"solar"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"OfferExpenseTemplate"}}]}}]}}]}},...OfferExpenseTemplateFragmentDoc.definitions]} as unknown as DocumentNode<NewOfferExpensesQuery, NewOfferExpensesQueryVariables>;
export const SolarProductPackagesDocument = {"kind":"Document", "definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"solarProductPackages"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"solarProductPackages"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"onlyDefaultBattery"},"value":{"kind":"BooleanValue","value":true}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"packageID"}},{"kind":"Field","name":{"kind":"Name","value":"maximumEnergyExpenditure"}},{"kind":"Field","name":{"kind":"Name","value":"discount"}},{"kind":"Field","name":{"kind":"Name","value":"solarPanel"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"SolarPanel"}}]}},{"kind":"Field","name":{"kind":"Name","value":"inverter"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Inverter"}}]}},{"kind":"Field","name":{"kind":"Name","value":"batteries"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Battery"}}]}}]}}]}},...SolarPanelFragmentDoc.definitions,...BoxSizeFragmentDoc.definitions,...InverterFragmentDoc.definitions,...CylinderSizeFragmentDoc.definitions,...BatteryFragmentDoc.definitions]} as unknown as DocumentNode<SolarProductPackagesQuery, SolarProductPackagesQueryVariables>;
export const AddressSavingsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"addressSavings"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"dawaId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"addressSavings"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"dawaId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"dawaId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"results"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"savings"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"saved"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"price"}},{"kind":"Field","name":{"kind":"Name","value":"emission"}},{"kind":"Field","name":{"kind":"Name","value":"priceByYear"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"types"}},{"kind":"Field","name":{"kind":"Name","value":"paybackMonths"}},{"kind":"Field","name":{"kind":"Name","value":"products"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"price"}},{"kind":"Field","name":{"kind":"Name","value":"heatPumpIndoorUnit"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"model"}},{"kind":"Field","name":{"kind":"Name","value":"brand"}},{"kind":"Field","name":{"kind":"Name","value":"imageUrl"}},{"kind":"Field","name":{"kind":"Name","value":"price"}}]}},{"kind":"Field","name":{"kind":"Name","value":"heatPumpOutdoorUnit"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"model"}},{"kind":"Field","name":{"kind":"Name","value":"brand"}},{"kind":"Field","name":{"kind":"Name","value":"imageUrl"}},{"kind":"Field","name":{"kind":"Name","value":"price"}}]}},{"kind":"Field","name":{"kind":"Name","value":"solarPanel"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"model"}},{"kind":"Field","name":{"kind":"Name","value":"brand"}},{"kind":"Field","name":{"kind":"Name","value":"imageUrl"}},{"kind":"Field","name":{"kind":"Name","value":"price"}},{"kind":"Field","name":{"kind":"Name","value":"annualProduction"}},{"kind":"Field","name":{"kind":"Name","value":"quantity"}}]}},{"kind":"Field","name":{"kind":"Name","value":"inverter"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"model"}},{"kind":"Field","name":{"kind":"Name","value":"brand"}},{"kind":"Field","name":{"kind":"Name","value":"imageUrl"}},{"kind":"Field","name":{"kind":"Name","value":"price"}}]}},{"kind":"Field","name":{"kind":"Name","value":"battery"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"model"}},{"kind":"Field","name":{"kind":"Name","value":"brand"}},{"kind":"Field","name":{"kind":"Name","value":"imageUrl"}},{"kind":"Field","name":{"kind":"Name","value":"price"}},{"kind":"Field","name":{"kind":"Name","value":"capacity"}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<AddressSavingsQuery, AddressSavingsQueryVariables>;